<template>
  <div>
    <autoLogout />

    <loader :loader="loader" />
    <!-- Fin Grupo de notificaiones -->
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text :class="[listHisCons.length < 6 ? 'calendar' : '']">
          <v-row align="baseline" justify="center" class="pb-4" dense>
            <branch-offices-list :classOfDiv="cols"  
            v-on:triggerChange="branchOfficeSelected"
            :model="idBranchOfficeSelected"
            />

            <v-col cols="12" md="3" xl="3" sm="12">
              <vc-date-picker color="green" v-model="range" is-range :max-date="new Date()" class="pb-0">
                <template v-slot="{ inputEvents }">
                  <div class="d-flex justify-center align-center">
                    <v-text-field v-on="inputEvents.start" :value="rangeComputed" label="Seleccione fecha" 
                      :append-icon="validData ? 'mdi-eraser' : 'mdi-calendar'" @click:append="clearCalendar"
                      :disabled-input="validData"></v-text-field>
                  </div>
                </template>
              </vc-date-picker>
            </v-col>

            <v-col>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line 
                hide-details></v-text-field>
            </v-col>
          </v-row>

          <v-data-table :headers="headers" :items="listHisCons" :search="search" :items-per-page="10" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
            no-data-text="Sin resultados disponibles" dense fixed-header height="auto">
            <template v-slot:[`item.nameStatusMedical`]="{ item }">
              <span v-if="item.statusMedicalPractice === 4" class="red--text">{{
      item.nameStatusMedical
    }}</span>
              <span v-if="item.statusMedicalPractice === 3" class="success--text">{{ item.nameStatusMedical }}</span>
            </template>
            <!-- getDataPatient(item) -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small icon @click="getMedicalPractice(item)" :disabled="item.status === 'Pendiente' ||
      item.status === 'Cancelado' ||
      item.status === 'Reprogramado' ||
      item.statusMedicalPractice == 4
      ">
                    <v-icon color="blue" v-bind="attrs" v-on="on">
                      mdi-information-variant
                    </v-icon>
                  </v-btn>
                </template>
                <span>Ver información de consulta</span>
              </v-tooltip>

              <v-menu offset-y :nudge-width="200" :close-on-content-click="true" v-if="item.statusMedicalPractice == 3">
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn small icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <span>Más opciones</span>
                  </v-tooltip>
                </template>
                <!-- getDataPatientUpdate(item) -->
                <v-list dense>
                  <v-list-item link :disabled="item.statusMedicalPractice == 4" @click="getProducts(item)" v-if="$utilFront.withPermission(
      $prm.MODULE_CONSULTATION_EDIT_ALL
    ) || $utilFront.isSameHR(item.idHumanResource)
      ">
                    <v-list-item-icon>
                      <v-icon color="warning" size="20px"> mdi-pencil </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Editar consulta</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item link @click="getMedicalPracticeDetails(item, 2)"
                    :disabled="item.statusMedicalPractice == 4">
                    <v-list-item-icon>
                      <v-icon color="error"> mdi-file-pdf-box </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Orden de estudio</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item link @click="getMedicalPracticeDetails(item, 1)"
                    :disabled="item.statusMedicalPractice == 4">
                    <v-list-item-icon>
                      <v-icon color="error"> mdi-file-pdf-box </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Nota médica </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item link @click="getMedicalPracticeDetails(item, 3)"
                    :disabled="item.statusMedicalPractice == 4">
                    <v-list-item-icon>
                      <v-icon color="error"> mdi-file-pdf-box </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Historia clínica </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item link @click="exportPDF(item)" v-if="item.idPrescription != null">
                    <v-list-item-icon>
                      <v-icon color="error"> mdi-file-pdf-box </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Receta médica </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions align="center">
          <v-col>
            <export-import-btn texto="Exportar Consultas" icono="export" color="green darken-1" :disabled="loader"
              @accion="exportMedicalPractice(2)" />
          </v-col>
        </v-card-actions>
      </v-card>
      <encabezado :elementos="titleConsultation" v-if="showAction(2)" />
      <v-card v-if="showAction(2)">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <h3 class="font-weight-black mb-5">Información de consulta</h3>
              </v-col>
              <v-col md="2">
                <h3 class="font-weight-black mb-5">
                  Id Consulta
                  <span class="error--text">{{
      medicalPractice.diagnosticPersonInfo.idMedicalPractice
    }}</span>
                </h3>
              </v-col>
            </v-row>
            <v-row justify="space-around" v-if="flagComponentInfo">
              <!-- <v-col>
                <div class="row">
                  <div class="col col-md-3 col-sm-6">
                    <v-text-field
                      disabled
                      v-model="medicalPractice.diagnosticPersonInfo.fullName"
                      label="Paciente"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </div>
                  <div class="col col-md-3 col-sm-6">
                    <v-text-field
                      disabled
                      v-model="medicalPractice.diagnosticPersonInfo.curp"
                      label="CURP"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </div>
                  <div class="col col-md-3 col-sm-6">
                    <v-text-field
                      disabled
                      v-model="medicalPractice.genderName"
                      label="Sexo"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </div>
                  <div class="col col-md-3 col-sm-6">
                    <v-text-field
                      disabled
                      v-model="old"
                      label="Edad"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </div>
                </div>
              </v-col> -->
              <v-col cols="12" md="12" sm="12" v-if="medicalPractice && medicalPractice.diagnosticPersonInfo">
                <patient-information :model="medicalPractice.diagnosticPersonInfo" @patientLoaded="onPatientLoaded"/>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <Patient-consultation-info :model="medicalPractice.diagnosticPersonInfo" />
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col>
                <div class="row">
                  <div class="col col-md-3 col-sm-6">
                    <v-text-field
                      disabled
                      v-model="dateInfo"
                      label="Fecha de consulta"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </div>
                </div>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col>
                <h3 class="font-weight-black my-5">Signos vitales</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" v-for="(input, index) in vitalSign" :key="index">
                <v-text-field :label="input.label" :value="input.value" :suffix="input.suffix" disabled dense></v-text-field>
              </v-col>
            </v-row>
           
            <v-expansion-panels class="mt-5 mb-10" v-model="panelCalculators">
  <v-expansion-panel
    v-for="(calculator, index) in filteredCalculators"
    :key="index"
  >
    <v-expansion-panel-header>
      <v-row dense class="text-left">
        <v-col cols="12" sm="12" md="12">
          <v-banner
            color="blue-grey lighten-5"
            class="br black--text"
            shaped
            single-line
            dense
            align="left"
          >
            <v-icon class="mr-2">mdi-chart-donut</v-icon>
            {{ calculator.name }}
          </v-banner>
        </v-col>
      </v-row>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <v-container>
        <v-row>
          <v-col
            v-for="(question, qIndex) in calculator.dataQuestions"
            :key="qIndex"
            cols="12"
          >
            <validation-provider
              v-slot="{ errors }"
              :rules="{ required: question.required }"
              :name="question.name"
            >
              <v-autocomplete
                v-if="question.typeAnswer === 2"
                v-model="question.answerClosed"
                :items="question.answers"
                item-value="idAnswer"
                item-text="name"
                :label="question.name"
                color="#59805c"
                clearable
                dense
                :error-messages="errors"
                disabled
              >
                <template v-slot:selection="data">
                  {{ data.item.name }}
                </template>
                <template v-slot:item="data">
                  {{ data.item.name }}
                </template>
              </v-autocomplete>
              <v-text-field
                v-else-if="question.typeAnswer === 1"
                v-model="question.answerOpen"
                :label="question.name"
                dense
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>

          <!-- ========================== -->
          <!-- FINDRISC (ETEL-01) -->
          <!-- ========================== -->
          <v-col
            cols="12"
            md="7"
            v-if="calculator.idCalculator === 'ETEL-01'"
          >
            <v-data-table
              hide-default-footer
              :items="interpretation"
              :headers="headersDiabetesResults"
              class="elevation-1"
            />
          </v-col>

          <v-col
            cols="12"
            md="5"
            v-if="calculator.idCalculator === 'ETEL-01'"
          >
            <v-card outlined>
              <v-card-title class="text-h6">
                Interpretación:
              </v-card-title>
              <v-card-text>
                <div>
                  <p>
                    <strong>Puntuación total:</strong>
                    {{ calculator.score }}
                  </p>
                  <p>
                    <strong>Riesgo de desarrollar diabetes en 10 años:</strong>
                    {{ getRiskInterpretation(calculator).riskPercentage }}
                  </p>
                  <p>
                    <strong>Interpretación:</strong>
                    {{ getRiskInterpretation(calculator).riskInterpretation }}
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- ========================== -->
          <!-- HIPERPLASIA (ETEL-03) -->
          <!-- ========================== -->
          <v-col
  cols="12"
  md="12"
  v-if="calculator.idCalculator === 'ETEL-03'"
>
  <v-card outlined>
    <v-card-title class="text-h6">
      Valoración:
    </v-card-title>
    <v-card-text>
      <div>
        <p>
          <strong>Puntaje total:</strong>
          {{ getCalculatorPoints(calculator) }}
        </p>
        <p>
          <strong>Sintomatología:</strong>
          {{ getHiperplasiaInterpretation(calculator) }}
        </p>
      </div>

      <v-row class="mt-3">
        <v-col cols="12">
          <v-simple-table>
            <thead>
              <tr>
                <th>Puntuación total</th>
                <th>Sintomatología</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>De 1 a 7 puntos</td>
                <td class="bg-green">Leve</td>
              </tr>
              <tr>
                <td>De 8 a 19 puntos</td>
                <td class="bg-yellow">Moderada</td>
              </tr>
              <tr>
                <td>Arriba de 20 puntos</td>
                <td class="bg-red">Severa</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
      <!-- Fin de la tabla -->
    </v-card-text>
  </v-card>
</v-col>

          <!-- =========================== -->
          <!-- RIESGO CARDIOVASCULAR (ETEL-02) -->
          <!-- =========================== -->
          <v-col
  cols="12"
  md="12"
  v-if="calculator.idCalculator === 'ETEL-02'"
>
      <v-container fluid>
        <v-row align="center" justify="space-around">

          <v-col cols="12" md="6" class="text-center">
            <p class="subtitle-1">Porcentaje de Riesgo Cardiovascular:</p>
            <h1 class="display-1 font-weight-bold">
              {{ getCardioRiskForCalculator(calculator) }}%
            </h1>
          </v-col>

          <v-col cols="12" md="4" class="d-flex justify-center">
            <v-card outlined class="pa-2 compact-risk-table">
              <v-card-title
                class="text-center"
                style="background-color: #008000; color: #fff; font-size: 0.85rem; padding: 4px;"
              >
                Tabla de porcentaje referencial
              </v-card-title>

              <v-simple-table>
                <tbody>
                  <tr>
                    <td class="bg-darkest-red" style="width: 24px;"></td>
                    <td>≥ 50 %</td>
                  </tr>
                  <tr>
                    <td class="bg-dark-red"></td>
                    <td>40 – 49 %</td>
                  </tr>
                  <tr>
                    <td class="bg-red"></td>
                    <td>30 – 39 %</td>
                  </tr>
                  <tr>
                    <td class="bg-orange"></td>
                    <td>20 – 29 %</td>
                  </tr>
                  <tr>
                    <td class="bg-yellow"></td>
                    <td>10 – 19 %</td>
                  </tr>
                  <tr>
                    <td class="bg-light-green"></td>
                    <td>5 – 9 %</td>
                  </tr>
                  <tr>
                    <td class="bg-green"></td>
                    <td>&lt; 5 %</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>

        </v-row>
      </v-container>
</v-col>
        </v-row>
      </v-container>
    </v-expansion-panel-content>
  </v-expansion-panel>
</v-expansion-panels>


            <v-row>
              <v-col>
                <h3 class="font-weight-black my-5">Antecedentes</h3>
              </v-col>
            </v-row>

            <v-expansion-panels class="my-10" v-model="panelHF" multiple>
              <v-expansion-panel v-for="(item, index) in heredoFamiliar" :key="index">
                <v-expansion-panel-header>
                  {{ item.name }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row align="center">
                    <v-col v-for="(question, subindex) in item.questions" :key="subindex">
                      <span>{{ question.name }}</span>

                      <v-radio-group v-if="question.typeAnswer == 2 || question.typeAnswer == 4
      " v-model="question.idAnswer" disabled :required="question.required == 1">
                        <v-radio v-for="(answer, sub_subindex) in question.answers" :key="sub_subindex"
                          :value="answer.idAnswer" :label="answer.name" disabled />
                      </v-radio-group>

                      <v-autocomplete v-if="question.typeAnswer == 3" v-model="question.selectedAnswers"
                        :items="question.answers" item-text="name" item-value="idAnswer" auto-select-first chips
                        clearable deletable-chips multiple small-chips dense disabled
                        :required="question.required == 1" />

                      <v-text-field v-if="(question.typeAnswer == 1 ||
      question.typeAnswer == 4) &&
      question.typeData != 6
      " v-model="question.answer" :type="question.typeDataText" :required="question.required == 1" autocomplete="off"
                        dense clearable disabled />

                      <v-textarea v-if="(question.typeAnswer == 1 ||
      question.typeAnswer == 4) &&
      question.typeData == 6
      " v-model="question.answer" outlined dense clearable disabled />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels class="mt-10 mb-5" v-model="panelPL" multiple>
              <v-expansion-panel v-for="(item, index) in pathologicals" :key="index">
                <v-expansion-panel-header>
                  {{ item.name }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row align="baseline">
                    <v-col v-for="(question, subindex) in item.questions" :key="subindex">
                      <span>{{ question.name }}</span>

                      <v-radio-group v-if="question.typeAnswer == 2 || question.typeAnswer == 4
      " v-model="question.idAnswer" disabled :required="question.required == 1">
                        <v-radio v-for="(answer, sub_subindex) in question.answers" :key="sub_subindex"
                          :value="answer.idAnswer" :label="answer.name" disabled />
                      </v-radio-group>

                      <v-autocomplete v-if="question.typeAnswer == 3" v-model="question.selectedAnswers"
                        :items="question.answers" item-text="name" item-value="idAnswer" auto-select-first chips
                        clearable deletable-chips multiple disabled small-chips dense
                        :required="question.required == 1" />

                      <v-text-field v-if="(question.typeAnswer == 1 ||
      question.typeAnswer == 4) &&
      question.typeData != 6
      " v-model="question.answer" disabled :type="question.typeDataText" :required="question.required == 1"
                        autocomplete="off" dense clearable />

                      <v-textarea v-if="(question.typeAnswer == 1 ||
      question.typeAnswer == 4) &&
      question.typeData == 6
      " v-model="question.answer" outlined disabled dense clearable />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-row v-if="medicalPractice.genderName == 'Femenino'">
  <v-col cols="12" md="4">
    <validation-provider name="¿Está embarazada?" rules="required" v-slot="{ errors }">
      <span>¿Está embarazada? <span class="error--text">*</span></span>
      <v-radio-group v-model="isPregnant" :error-messages="errors" row  disabled>
        <v-radio label="Sí" :value="1" />
        <v-radio label="No" :value="0" />
      </v-radio-group>
    </validation-provider>
  </v-col>
</v-row>

            <v-expansion-panels class="mt-3 mb-5" v-model="panelOG" v-if="medicalPractice.genderName == 'Femenino'"
              multiple>
              <v-expansion-panel v-for="(item, index) in ginecologicos" :key="index" v-model="panelGO">
                <v-expansion-panel-header>
                  {{ item.name }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row align="baseline">
                    <v-col v-for="(question, subindex) in item.questions" :key="subindex" cols="12" md="4" xl="6"
                      sm="12">
                      <span>{{ question.name }}</span>
                      <validation-provider v-slot="{ errors }" :name="question.name"
                        :rules="question.required == 1 ? 'required' : ''">
                        <v-radio-group v-if="question.typeAnswer == 2 || question.typeAnswer == 4
      " v-model="question.idAnswer" :error-messages="errors" :required="question.required == 1" disabled>
                          <v-radio v-for="(answer, sub_subindex) in question.answers" :key="sub_subindex"
                            :value="answer.idAnswer" :label="answer.name" />
                        </v-radio-group>

                        <v-autocomplete v-if="question.typeAnswer == 3" v-model="question.selectedAnswers"
                          :items="question.answers" item-text="name" item-value="idAnswer" :error-messages="errors"
                          auto-select-first chips clearable deletable-chips multiple small-chips dense
                          :required="question.required == 1" disabled />

                          <v-text-field
  v-else-if="(question.typeAnswer == 1 || question.typeAnswer == 4) && question.typeData != 6"
  v-model="question.answer"
  :error-messages="errors"
  :type="question.typeDataText"
  :required="question.required == 1"
  autocomplete="off"
  dense
  clearable
  disabled
/>


                        <v-textarea v-if="(question.typeAnswer == 1 ||
      question.typeAnswer == 4) &&
      question.typeData == 6
      " v-model="question.answer" :error-messages="errors" outlined dense clearable auto-grow disabled 
          :disabled="(question.idQuestion === 'C-29' || question.idQuestion === 'C-30') && isPregnant === 0"
      />
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-row v-if="false">
              <v-col>
                <h3 class="font-weight-black mb-5">Tratamiento</h3>
              </v-col>
            </v-row>
            <v-row v-if="false">
              <v-col class="mb-5">
                <validation-provider v-slot="{ errors }" name="Tratamiento">
                  <v-textarea v-model="medicalPractice.treatment.treatment" disabled value="" solo label=""
                    :error-messages="errors" outlined dense clearable>
                  </v-textarea>
                </validation-provider>
              </v-col>
            </v-row>

            <v-row 
  class="mt-5"       
  align="center"     
  justify="start"    
  dense
>
  <v-col cols="12" md="4">
    <validation-provider v-slot="{ errors }" name="¿Tiene alguna discapacidad?" rules="required">
      <v-radio-group
        v-model="patient.hasDisability"
        label="¿Tiene alguna discapacidad?"
        row
        :error-messages="errors"
        disabled
      >
        <v-radio label="Sí" value="1"></v-radio>
        <v-radio label="No" value="0"></v-radio>
      </v-radio-group>
    </validation-provider>
  </v-col>

  <v-col 
  cols="12" 
  md="4" 
  v-if="patient.hasDisability === '1'"
  class="d-flex align-center"
>
  <div class="d-flex align-center">
    <span class="mr-2 grey--text text--darken-3" style="white-space: nowrap;">
      Seleccione la discapacidad:
    </span>

    <v-select
      v-model="patient.disabilityType"
      :items="disabilityOptions"
      item-text="text"
      item-value="value"
      label=""
      hide-details="auto"
      clearable
      dense
      class="mt-n2"           
      style="margin-top: -5px;" 
      disabled
    />
  </div>
</v-col>


</v-row>
            <h3 class="font-weight-black my-10">Nota médica</h3>
            <v-row>
              <v-col @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
                <vue-editor v-model="content" disabled />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="mt-5">
                <v-autocomplete v-model="cieSelected" label="Diagnóstico" no-data-text="Sin resultados por mostrar"
                  required multiple chips :items="cie" :item-text="cie.text" :item-value="cie.value"
                  disabled></v-autocomplete>
              </v-col>
            </v-row>

            <v-row  align="center" justify="center">
              <v-col md="8" sm="12" class="mb-5" @click.right.prevent @copy.prevent @paste.prevent
                ondrop="return false;">
                <span>Detalles de diagnóstico</span>
                <v-textarea v-model="diagnosticDetails" solo outlined dense readonly disabled>
                </v-textarea>
              </v-col>
              <v-col v-if="hasSubsequent">
                <v-autocomplete label="Diagnóstico subsecuente*" v-model="subsequent" disabled dense
                  no-data-text="Sin resultados disponibles" required :clear-icon="$cnst.CLEAR_ICON" clearable
                  :items="['SI', 'NO']" />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <h3 class="font-weight-black mb-10">Receta</h3>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col>
                <v-data-table :headers="headersProducts" :items="products" :items-per-page="-1" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                  no-data-text="Sin resultados disponibles" class="mx-5" dense hide-default-footer fixed-header
                  height="auto">
                  <template v-slot:[`item.count`]="{ index }">
                    {{ index + 1 }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }" v-if="action == 3">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon color="error" @click="deleteProductAdded(item.value, item)"
                          :disabled="prescription">
                          <v-icon v-bind="attrs" v-on="on"> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>{{
      prescription
        ? "Receta dispensada"
        : "Eliminar medicamento"
    }}</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <h3 class="font-weight-black mb-10">Estudios</h3>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col>
                <v-data-table :headers="headersStudies" :items="listStudies" :items-per-page="-1" :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con la búsqueda" loading-text="Cargando..."
                  no-data-text="Sin resultados disponibles" class="mx-5" dense hide-default-footer>
                  <template v-slot:[`item.count`]="{ index }">
                    {{ index + 1 }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row align="center" justify="center">
            <v-col class="text-center my-3">
              <v-btn text large color="error" @click="changeAction(1)">
                <v-icon left>mdi-chevron-left</v-icon> Volver
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <!-- <v-btn
          v-scroll="onScroll"
          v-show="fab"
          fab
          dark
          fixed
          bottom
          right
          color="primary"
          @click="$vuetify.goTo('#inicio')"
        >
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn> -->
      </v-card>

      <!-- UPDATE CONSULTATION -->
      <encabezado v-if="showAction(3)" :elementos="titleUpdateCons" :nameRoute="nameRoute" :paramsRoute="paramsRoute"
        :disabledButton="disabledHeader" />
      <v-card v-if="showAction(3)">
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form lazy-validation v-on:submit.prevent>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black mb-5">
                      Información de consulta
                    </h3>
                  </v-col>
                  <v-col md="2">
                    <h3 class="font-weight-black mb-5">
                      Id Consulta
                      <span class="error--text">{{
      medicalPractice.diagnosticPersonInfo.idMedicalPractice
    }}</span>
                    </h3>
                  </v-col>
                </v-row>
                <v-row justify="space-around" v-if="flagComponentInfo">
                  <!-- <v-col>
                    <div class="row">
                      <div class="col col-md-3 col-sm-6">
                        <v-text-field
                          disabled
                          v-model="
                            medicalPractice.diagnosticPersonInfo.fullName
                          "
                          label="Nombre del paciente"
                          required
                          autocomplete="off"
                        ></v-text-field>
                      </div>
                      <div class="col col-md-3 col-sm-6">
                        <v-text-field
                          disabled
                          v-model="medicalPractice.diagnosticPersonInfo.curp"
                          label="CURP"
                          required
                          autocomplete="off"
                        ></v-text-field>
                      </div>
                      <div class="col col-md-3 col-sm-6">
                        <v-text-field
                          disabled
                          v-model="medicalPractice.genderName"
                          label="Sexo"
                          required
                          autocomplete="off"
                        ></v-text-field>
                      </div>
                      <div class="col col-md-3 col-sm-6">
                        <v-text-field
                          disabled
                          v-model="old"
                          label="Edad"
                          required
                          autocomplete="off"
                        ></v-text-field>
                      </div>
                    </div>
                  </v-col> -->
                  <v-col cols="12" md="12" sm="12" v-if="medicalPractice && medicalPractice.diagnosticPersonInfo">
                    <patient-information :model="medicalPractice.diagnosticPersonInfo" @patientLoaded="onPatientLoaded" />
                  </v-col>
                  <v-col cols="12" md="12" sm="12">
                    <Patient-consultation-info :model="medicalPractice.diagnosticPersonInfo" />
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      disabled
                      v-model="dateInfo"
                      label="Fecha de consulta"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </v-col>
                </v-row> -->
                <h3 class="font-weight-black mt-5">Signos vitales</h3>
                <v-expansion-panels class="my-10" v-model="panelSV">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Signos vitales
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <div class="col-md-4" v-for="(input, index) in inputsVitalSign" :key="index">
                          <validation-provider v-slot="{ errors }" :rules="input.required ? 'required' : ''"
                            :name="input.label">
                            <v-text-field dense v-model="vitalSign[index].description" :label="input.label"
                              :suffix="input.suffix" :required="input.required" :type="input.type"
                              :error-messages="errors" min="0" @change="
      panelDis = false;
    calculateIMC();
    "></v-text-field>
                          </validation-provider>
                        </div>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                 <v-expansion-panels class="mt-5 mb-10" v-model="panelCalculators">
  <v-expansion-panel
    v-for="(calculator, index) in filteredCalculators"
    :key="index"
  >
    <v-expansion-panel-header>
      <v-row dense class="text-left">
        <v-col cols="12" sm="12" md="12">
          <v-banner
            color="blue-grey lighten-5"
            class="br black--text"
            shaped
            single-line
            dense
            align="left"
          >
            <v-icon class="mr-2">mdi-chart-donut</v-icon>
            {{ calculator.name }}
          </v-banner>
        </v-col>
      </v-row>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <v-container>
        <v-row>
          <!-- Aquí están las preguntas -->
          <v-col
            v-for="(question, qIndex) in calculator.dataQuestions"
            :key="qIndex"
            cols="12"
          >
            <validation-provider
              v-slot="{ errors }"
              :rules="{ required: question.required }"
              :name="question.name"
            >
              <v-autocomplete
                v-if="question.typeAnswer === 2"
                v-model="question.answerClosed"
                :items="question.answers"
                item-value="idAnswer"
                item-text="name"
                :label="question.name"
                color="#59805c"
                clearable
                dense
                :error-messages="errors"
              >
                <template v-slot:selection="data">
                  {{ data.item.name }}
                </template>
                <template v-slot:item="data">
                  {{ data.item.name }}
                </template>
              </v-autocomplete>
              <v-text-field
                v-else-if="question.typeAnswer === 1"
                v-model="question.answerOpen"
                :label="question.name"
                dense
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>

          <!-- ========================== -->
          <!-- FINDRISC (ETEL-01) -->
          <!-- ========================== -->
          <v-col
            cols="12"
            md="7"
            v-if="calculator.idCalculator === 'ETEL-01'"
          >
            <v-data-table
              hide-default-footer
              :items="interpretation"
              :headers="headersDiabetesResults"
              class="elevation-1"
            />
          </v-col>

          <v-col
            cols="12"
            md="5"
            v-if="calculator.idCalculator === 'ETEL-01'"
          >
            <v-card outlined>
              <v-card-title class="text-h6">
                Interpretación:
              </v-card-title>
              <v-card-text>
                <div>
                  <p>
                   Puntuación total:
                   <strong>{{ getCalculatorPoints(calculator) }}</strong>
                  </p>
                  <p>
                   Riesgo de desarrollar diabetes en 10 años:
                   <strong>{{ getRiskInterpretation(calculator).riskPercentage }}</strong>
                  </p>
                  <p>
                   Interpretación:
                   <strong>{{ getRiskInterpretation(calculator).riskInterpretation }}</strong>
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- ========================== -->
          <!-- HIPERPLASIA (ETEL-03) -->
          <!-- ========================== -->
          <v-col
  cols="12"
  md="12"
  v-if="calculator.idCalculator === 'ETEL-03'"
>
  <v-card outlined>
    <v-card-title class="text-h6">
      Valoración:
    </v-card-title>
    <v-card-text>
      <div>
        <p>
         Puntaje total:
         <strong> {{ getCalculatorPoints(calculator) }}</strong>
        </p>
        <p>
         Sintomatología:
          {{ getHiperplasiaInterpretation(calculator) }}
        </p>
      </div>

      <v-row class="mt-3">
        <v-col cols="12">
          <v-simple-table>
            <thead>
              <tr>
                <th>Puntuación total</th>
                <th>Sintomatología</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>De 1 a 7 puntos</td>
                <td class="bg-green">Leve</td>
              </tr>
              <tr>
                <td>De 8 a 19 puntos</td>
                <td class="bg-yellow">Moderada</td>
              </tr>
              <tr>
                <td>Arriba de 20 puntos</td>
                <td class="bg-red">Severa</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</v-col>

          <!-- =========================== -->
          <!-- RIESGO CARDIOVASCULAR (ETEL-02) -->
          <!-- =========================== -->
          <v-col
  cols="12"
  md="12"
  v-if="calculator.idCalculator === 'ETEL-02'"
>
      <v-container fluid>
        <v-row align="center" justify="space-around">

          <v-col cols="12" md="6" class="text-center">
            <p class="subtitle-1">Porcentaje de Riesgo Cardiovascular:</p>
            <h1 class="display-1 font-weight-bold">
              {{ getCardioRiskForCalculator(calculator) }}%
            </h1>
          </v-col>

          <v-col cols="12" md="4" class="d-flex justify-center">
            <v-card outlined class="pa-2 compact-risk-table">
              <v-card-title
                class="text-center"
                style="background-color: #008000; color: #fff; font-size: 0.85rem; padding: 4px;"
              >
                Tabla de porcentaje referencial
              </v-card-title>

              <v-simple-table>
                <tbody>
                  <tr>
                    <td class="bg-darkest-red" style="width: 24px;"></td>
                    <td>≥ 50 %</td>
                  </tr>
                  <tr>
                    <td class="bg-dark-red"></td>
                    <td>40 – 49 %</td>
                  </tr>
                  <tr>
                    <td class="bg-red"></td>
                    <td>30 – 39 %</td>
                  </tr>
                  <tr>
                    <td class="bg-orange"></td>
                    <td>20 – 29 %</td>
                  </tr>
                  <tr>
                    <td class="bg-yellow"></td>
                    <td>10 – 19 %</td>
                  </tr>
                  <tr>
                    <td class="bg-light-green"></td>
                    <td>5 – 9 %</td>
                  </tr>
                  <tr>
                    <td class="bg-green"></td>
                    <td>&lt; 5 %</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>

        </v-row>
      </v-container>
</v-col>
        </v-row>
      </v-container>
    </v-expansion-panel-content>
  </v-expansion-panel>
</v-expansion-panels>

                <h3 class="font-weight-black mt-5">Antecedentes</h3>
                <v-expansion-panels class="my-10" v-model="panelHF" multiple>
                  <v-expansion-panel v-for="(item, index) in heredoFamiliar" :key="index">
                    <v-expansion-panel-header>
                      {{ item.name }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row align="center">
                        <v-col v-for="(question, subindex) in item.questions" :key="subindex">
                          <span>{{ question.name }}</span>

                          <v-radio-group v-if="question.typeAnswer == 2 ||
      question.typeAnswer == 4
      " v-model="question.idAnswer" disabled :required="question.required == 1">
                            <v-radio v-for="(answer, sub_subindex) in question.answers" :key="sub_subindex"
                              :value="answer.idAnswer" :label="answer.name" disabled />
                          </v-radio-group>

                          <v-autocomplete v-if="question.typeAnswer == 3" v-model="question.selectedAnswers"
                            :items="question.answers" item-text="name" item-value="idAnswer" auto-select-first chips
                            clearable deletable-chips multiple small-chips dense disabled
                            :required="question.required == 1" />

                          <v-text-field v-if="(question.typeAnswer == 1 ||
      question.typeAnswer == 4) &&
      question.typeData != 6
      " v-model="question.answer" :type="question.typeDataText" :required="question.required == 1" autocomplete="off"
                            dense clearable disabled />

                          <v-textarea v-if="(question.typeAnswer == 1 ||
      question.typeAnswer == 4) &&
      question.typeData == 6
      " v-model="question.answer" outlined dense clearable />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-expansion-panels class="mt-10 mb-10" v-model="panelPL" multiple>
                  <v-expansion-panel v-for="(item, index) in pathologicals" :key="index">
                    <v-expansion-panel-header>
                      {{ item.name }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row align="baseline">
                        <v-col v-for="(question, subindex) in item.questions" :key="subindex">
                          <span>{{ question.name }}</span>

                          <v-radio-group v-if="question.typeAnswer == 2 ||
      question.typeAnswer == 4
      " v-model="question.idAnswer" disabled :required="question.required == 1">
                            <v-radio v-for="(answer, sub_subindex) in question.answers" :key="sub_subindex"
                              :value="answer.idAnswer" :label="answer.name" disabled />
                          </v-radio-group>

                          <v-autocomplete v-if="question.typeAnswer == 3" v-model="question.selectedAnswers"
                            :items="question.answers" item-text="name" item-value="idAnswer" auto-select-first chips
                            clearable deletable-chips multiple disabled small-chips dense
                            :required="question.required == 1" />

                          <v-text-field v-if="(question.typeAnswer == 1 ||
      question.typeAnswer == 4) &&
      question.typeData != 6
      " v-model="question.answer" disabled :type="question.typeDataText" :required="question.required == 1"
                            autocomplete="off" dense clearable />

                          <v-textarea v-if="(question.typeAnswer == 1 ||
      question.typeAnswer == 4) &&
      question.typeData == 6
      " v-model="question.answer" outlined dense clearable />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-row v-if="medicalPractice.genderName == 'Femenino'">
  <v-col cols="12" md="4">
    <validation-provider name="¿Está embarazada?" rules="required" v-slot="{ errors }">
      <span>¿Está embarazada? <span class="error--text">*</span></span>
      <v-radio-group v-model="isPregnant" :error-messages="errors" row>
        <v-radio label="Sí" :value="1" />
        <v-radio label="No" :value="0" />
      </v-radio-group>
    </validation-provider>
  </v-col>
</v-row>

                <v-expansion-panels class="mt-3 mb-5" v-model="panelGO" v-if="medicalPractice.genderName == 'Femenino'"
                  multiple>
                  <v-expansion-panel v-for="(item, index) in ginecologicos" :key="index" v-model="panelGO">
                    <v-expansion-panel-header>
                      {{ item.name }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row align="baseline">
                        <v-col v-for="(question, subindex) in item.questions" :key="subindex" cols="12" md="4" xl="6"
                          sm="12">
                          <span>{{ question.name }}</span>
                          <validation-provider v-slot="{ errors }" :name="question.name"
                          :rules="(question.idQuestion === 'C-29' || question.idQuestion === 'C-30') && isPregnant == 1 ? 'required' : (question.required == 1 ? 'required' : '')"
                          >
                            <v-radio-group v-if="question.typeAnswer == 2 ||
                               question.typeAnswer == 4
                               " v-model="question.idAnswer" :error-messages="errors" :required="question.required == 1">
                            <v-radio v-for="(answer,
                              sub_subindex) in question.answers" :key="sub_subindex" :value="answer.idAnswer" :label="answer.name" />
                            </v-radio-group>

                            <v-autocomplete v-if="question.typeAnswer == 3" v-model="question.selectedAnswers"
                              :items="question.answers" item-text="name" item-value="idAnswer" :error-messages="errors"
                              auto-select-first chips clearable deletable-chips multiple small-chips dense
                              :required="question.required == 1" />

                              <v-text-field
  v-else-if="(question.typeAnswer == 1 || question.typeAnswer == 4) && question.typeData != 6"
  v-model="question.answer"
  :error-messages="errors"
  :type="question.typeDataText"
  :required="question.required == 1"
  autocomplete="off"
  dense
  clearable
  :disabled=" (question.idQuestion === 'C-29' || question.idQuestion === 'C-30')&& isPregnant === 0"  
                />

                            <v-textarea v-if="(question.typeAnswer == 1 ||
      question.typeAnswer == 4) &&
      question.typeData == 6
      " v-model="question.answer" :error-messages="errors" outlined dense clearable auto-grow 
          :disabled="(question.idQuestion === 'C-29' || question.idQuestion === 'C-30') && isPregnant === 0"
              />
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-row 
  class="mt-5"       
  align="center"     
  justify="start"    
  dense
>
  <v-col cols="12" md="4">
    <validation-provider v-slot="{ errors }" name="¿Tiene alguna discapacidad?" rules="required">
      <v-radio-group
        v-model="patient.hasDisability"
        label="¿Tiene alguna discapacidad?"
        row
        :error-messages="errors"
      >
        <v-radio label="Sí" value="1"></v-radio>
        <v-radio label="No" value="0"></v-radio>
      </v-radio-group>
    </validation-provider>
  </v-col>

  <v-col 
  cols="12" 
  md="4" 
  v-if="patient.hasDisability === '1'"
  class="d-flex align-center"
>
  <div class="d-flex align-center">
    <span class="mr-2 grey--text text--darken-3" style="white-space: nowrap;">
      Seleccione la discapacidad:
    </span>

    <v-select
      v-model="patient.disabilityType"
      :items="disabilityOptions"
      item-text="text"
      item-value="value"
      label=""
      hide-details="auto"
      clearable
      dense
      class="mt-n2"           
      style="margin-top: -5px;" 
    />
  </div>
</v-col>


</v-row>

                <h3 class="font-weight-black my-5">Nota médica</h3>
                <v-row>
                  <v-col @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
                    <validation-provider v-slot="{ errors }" name="Nota médica" rules="required">
                      <vue-editor v-model="content" required :error-messages="errors" @input="onEditorInput"/>
                      <span class="error--text">{{ errors.toString() }}</span>
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="mt-5">
                    <validation-provider v-slot="{ errors }" name="Diagnóstico" rules="required">
                      <v-autocomplete v-model="cieSelected" label="Diagnóstico"
                        no-data-text="Sin resultados por mostrar" required multiple dense :error-messages="errors"
                        :items="cie" :item-text="cie.text" :item-value="cie.value">
                        <template v-slot:selection="data">
                          <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select"
                            @click:close="remove(data.item)">
                            {{ data.item.text }}
                          </v-chip>
                        </template>

                        <template v-slot:item="data">
                          <template>
                            <v-list-item-content>
                              <v-list-item-title v-html="data.item.text"></v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row  align="center" justify="center">
                  <v-col md="8" sm="12" class="mb-5" @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
                    <span>Detalles de diagnóstico</span>
                    <validation-provider v-slot="{ errors }" name="Detalles de diagnóstico" rules="required">
                      <v-textarea v-model="diagnosticDetails" solo label="" value="" :error-messages="errors"
                        :counter="1000" :maxlength="1000" outlined dense clearable auto-grow>
                      </v-textarea>
                    </validation-provider>
                  </v-col>
                  <v-col v-if="hasSubsequent">
                    <validation-provider v-slot="{ errors, valid }" name="Diagnóstico subsecuente" rules="required">
                      <v-autocomplete label="Diagnóstico subsecuente*" v-model="subsequent" required
                        :error-messages="errors" dense no-data-text="Sin resultados disponibles" 
                        :clear-icon="$cnst.CLEAR_ICON" clearable :items="['SI', 'NO']">
                        <v-icon slot="append" :color="valid ? 'success' : ''">
                          {{ valid && subsequent ? " mdi-check" : "" }}
                        </v-icon>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-btn color="secondary" rounded large @click="
      consulta.receta = true;
    $vuetify.goTo('#consulta');
    " :disabled="consulta.receta === true || prescription === true
      ">
                      <span v-if="!prescription">Receta médica</span><span v-if="prescription">Receta
                        dispensada</span><v-icon right>mdi-prescription</v-icon>
                    </v-btn>
                  </v-col>

                  <v-col class="text-center">
                    <v-btn color="secondary" rounded large @click="
      consulta.laboratorio = true;
    $vuetify.goTo('#consulta');
    " :disabled="consulta.laboratorio === true">
                      Especialidades<v-icon right>mdi-microscope</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <template>
                  <v-container>
                    <v-card flat>
                      <v-container v-if="consulta.receta == true" class="mt-5">
                        <v-row align="baseline" justify="center">
                          <v-col>
                            <p class="title">Receta médica</p>
                          </v-col>
                          <!-- <v-col class="text-right">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  plain
                                  icon
                                  color="error"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="consulta.receta = false"
                                >
                                  <v-icon size="30px">mdi-close</v-icon>
                                </v-btn>
                              </template>
          <span>Cerrar</span>
          </v-tooltip>
          </v-col> -->
                        </v-row>

                        <validation-observer ref="fmPres" v-slot="{ invalid }" disabled>
                          <v-form lazy-validation v-model="invalidPrescription">
                            <v-row>
                              <v-col>
                                <validation-provider v-slot="{ errors }" rules="required" name="Producto">
                                  <v-autocomplete prepend-icon="mdi-medical-bag" v-model="product.idProduct"
                                    :items="productsList" :item-text="productsList.text"
                                    :item-value="productsList.value" :error-messages="errors" label="Producto"
                                    @change="saveQuantity(product)" no-data-text="Sin medicamentos por mostrar"
                                    clearable return-object>
                                    <template v-slot:item="data">
                                      <v-tooltip top color="primary">
                                        <template slot="activator" slot-scope="{ on }">
                                          <v-list-item-content>
                                            <v-list-item-title v-on="on" v-html="data.item.text"></v-list-item-title>
                                          </v-list-item-content>
                                        </template>
                                        <small>{{
      data.item.description
    }}</small>
                                      </v-tooltip>
                                    </template>
                                  </v-autocomplete>
                                </validation-provider>
                              </v-col>

                              <v-col>
                                <validation-provider v-slot="{ errors }" name="Cantidad" :rules="checkStocks">
                                  <v-text-field prepend-icon="mdi-playlist-plus" v-model="product.request" type="number"
                                    label="Cantidad" min="0" :error-messages="errors"></v-text-field>
                                </validation-provider>
                              </v-col>

                              <v-col>
                                <validation-provider v-slot="{ errors }" name="Instrucciones" rules="required|max:500">
                                  <v-textarea prepend-icon="mdi-pencil" v-model="product.instruction"
                                    label="Instrucciones" auto-grow rows="1" :counter="500"
                                    :error-messages="errors"></v-textarea>
                                </validation-provider>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col>
                                <small v-if="$utilFront.isNonNull(quantity)">
                                    Cantidad en stock :{{ quantity }}
                                </small>
                              </v-col>
                            </v-row>

                            <v-row align="center" justify="space-around" class="mb-5 mt-4">
                              <v-btn color="secondary" text @click="resetPresForm()">Limpiar
                                <v-icon right>mdi-eraser</v-icon></v-btn>
                              <v-btn color="primary" @click="addProductPrescription()" :disabled="invalid">
                                Agregar <v-icon right>mdi-plus</v-icon></v-btn>
                            </v-row>
                          </v-form>
                        </validation-observer>
                      </v-container>
                      <v-row>
                        <v-col>
                          <div>
                            <v-container>
                              <!-- <span style="background-color:#E7E7E7; margin: 3%">Receta dispensada</span>-->
                              <v-card v-if="listProductsAdded.length > 0">
                                <v-simple-table dense fixed-header>
                                  <thead>
                                    <tr>
                                      <th>Causes</th>
                                      <th>Producto</th>
                                      <th>Instrucción</th>
                                      <th>Recetadas</th>
                                      <th>Eliminar</th>
                                    </tr>
                                  </thead>
                                  <tbody v-for="(item, index) in listProductsAdded" :key="index">
                                    <tr>
                                      <td>{{ item.product_key }}</td>
                                      <td>{{ item.name }}</td>
                                      <td>{{ item.instruction }}</td>
                                      <td class="text-center">
                                        {{ item.request }}
                                      </td>
                                      <td>
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon color="error" @click="
      deleteProductAdded(
        item.value,
        item
      )
      " :disabled="prescription">
                                              <v-icon v-bind="attrs" v-on="on">
                                                mdi-delete
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{
      prescription
        ? "Receta dispensada"
        : "Eliminar medicamento"
    }}</span>
                                        </v-tooltip>
                                      </td>
                                    </tr>
                                  </tbody>
                                </v-simple-table>
                              </v-card>
                            </v-container>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-container>
                </template>

                <template>
                  <v-container>
                    <v-card flat>
                      <v-container v-if="consulta.laboratorio == true" id="laboratorio" class="mt-5">
                        <v-row>
                          <v-col>
                            <p class="title">Especialidades</p>
                          </v-col>
                          <!-- <v-col class="text-right">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  plain
                                  icon
                                  color="error"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="consulta.laboratorio = false"
                                >
                                  <v-icon size="30px">mdi-close</v-icon>
                                </v-btn>
                              </template>
<span>Cerrar</span>
</v-tooltip>
</v-col> -->
                        </v-row>
                        <v-row v-if="medicalPractice && medicalPractice.diagnosticPersonInfo">
                          <v-col>
                            <v-col>
                              <SpecialitiesTabs 
                                ref="specTabs"
                                @addStudies="addStudies" 
                                @clear-labs="clearLabs"
                               @pending-selection="handlePendingSelection"
                                :patientData="medicalPractice.diagnosticPersonInfo"
                                :medicalPractice="medicalPractice"
                              />
                            </v-col>
                          </v-col>
                        </v-row>
                        <!-- <v-subheader>Información de cita</v-subheader>
                        <validation-observer
                          v-slot="{ invalid }"
                          ref="fmEst"
                          disabled
                        >
                          <v-form lazy-validation>
                            <v-row class="mb-2">
                              <v-col v-if="$utilFront.nonLite()">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Fecha y hora"
                                >
                                  <VueCtkDateTimePicker
                                    v-model="addLabStudy.startTime"
                                    :no-value-to-custom-elem="true || false"
                                    button-now-translation="Ahora"
                                    :minDate="currentDate"
                                    minute-interval="10"
                                  >
                                    <v-text-field
                                      :value="addLabStudy.startTime"
                                      clearable
                                      prepend-icon="mdi-calendar"
                                      label="Fecha y hora"
                                      no-autocomplete
                                      :rules="nameRules"
                                      :error-messages="errors"
                                      required
                                      @click="swDoctor = false"
                                    ></v-text-field>
                                  </VueCtkDateTimePicker>
                                </validation-provider>
                              </v-col>

                              <v-col md="4">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Especialidad"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    return-object
                                    v-model="addLabStudy.speciality"
                                    :items="specialitiesList"
                                    :item-text="specialitiesList.text"
                                    :item-value="specialitiesList.value"
                                    :error-messages="errors"
                                    clearable
                                    prepend-icon="mdi-hospital"
                                    label="Especialidad"
                                    @change="
                                      listModaltyBySpecialty(
                                        addLabStudy.speciality.value
                                      );
                                      swModalty = false;
                                    "
                                    required
                                  ></v-autocomplete>
                                </validation-provider>
                              </v-col>

                              <v-col
                                v-if="
                                  addLabStudy.speciality &&
                                    addLabStudy.speciality.value != 4 &&
                                    addLabStudy.speciality.value != 5 &&
                                    addLabStudy.speciality.value != 6 &&
                                    addLabStudy.speciality.value != 7
                                "
                              >
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Modalidad"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    return-object
                                    v-model="addLabStudy.modalty"
                                    :items="modaltiesList"
                                    :items-text="modaltiesList.text"
                                    :items-value="modaltiesList.value"
                                    :error-messages="errors"
                                    clearable
                                    label="Modalidad"
                                    no-data-text="Sin modalidad por mostrar"
                                    prepend-icon="mdi-radiology-box"
                                    @change="
                                      listStudyProfileByModality(
                                        addLabStudy.modalty.value
                                      );
                                      swProfile = false;
                                    "
                                    :disabled="swModalty"
                                    required
                                  ></v-autocomplete>
                                </validation-provider>
                              </v-col>

                              <v-col
                                v-if="
                                  addLabStudy.speciality &&
                                    addLabStudy.speciality.value != 4 &&
                                    addLabStudy.speciality.value != 5 &&
                                    addLabStudy.speciality.value != 6 &&
                                    addLabStudy.speciality.value != 7
                                "
                              >
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Perfil de estudio"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    return-object
                                    v-model="addLabStudy.idStudyModality"
                                    :items="profileStudiesList"
                                    :item-text="profileStudiesList.text"
                                    :item-value="profileStudiesList.value"
                                    :error-messages="errors"
                                    clearable
                                    no-data-text="Sin perfiles de estudio por mostrar"
                                    label="Perfil de estudio"
                                    prepend-icon="mdi-radiology-box-outline"
                                    :disabled="swProfile"
                                    @change="swBranchOffice = false"
                                    required
                                  ></v-autocomplete>
                                </validation-provider>
                              </v-col>
                              <v-col v-if="$utilFront.nonLite()">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Turno"
                                  rules="required"
                                >
                                  <v-autocomplete
                                    v-model="addLabStudy.turn"
                                    :items="turnList"
                                    :items-text="turnList.text"
                                    :items-value="turnList.value"
                                    :error-messages="errors"
                                    clearable
                                    prepend-icon="mdi-timer-sand"
                                    label="Turno"
                                    required
                                  ></v-autocomplete>
                                </validation-provider>
                              </v-col>
                            </v-row>
                            <div v-if="$utilFront.nonLite()">
                              <v-divider></v-divider>
                              <v-subheader>Información de envio</v-subheader>

                              <v-row class="mb-2">
                                <v-col>
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Motivo de envío"
                                    rules="required"
                                  >
                                    <v-autocomplete
                                      v-model="addLabStudy.type"
                                      :items="reasonsList"
                                      :item-text="reasonsList.text"
                                      :item-value="reasonsList.value"
                                      :error-messages="errors"
                                      clearable
                                      prepend-icon="mdi-help"
                                      label="Motivo de envío"
                                      required
                                    ></v-autocomplete>
                                  </validation-provider>
                                </v-col>

                                <v-col>
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Diagnostico presuntivo"
                                    rules="required"
                                  >
                                    <v-textarea
                                      v-model="addLabStudy.reason"
                                      :error-messages="errors"
                                      rows="1"
                                      auto-grow
                                      prepend-icon="mdi-pencil"
                                      label="Diagnostico presuntivo"
                                      clearable
                                      required
                                    ></v-textarea>
                                  </validation-provider>
                                </v-col>
                              </v-row>

                              <v-divider></v-divider>
                              <v-subheader>Información de destino</v-subheader>

                              <v-row>
                                <v-col>
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Clave presupuestal destino"
                                    rules="required"
                                  >
                                    <v-autocomplete
                                      return-object
                                      v-model="
                                        addLabStudy.branchOfficeDestination
                                      "
                                      :items="branchOfficeList"
                                      :items-text="branchOfficeList.text"
                                      :items-value="branchOfficeList.value"
                                      :error-messages="errors"
                                      clearable
                                      prepend-icon="mdi-hospital-building"
                                      label="Clave presupuestal destino"
                                      @change="
                                        listAllConsultingRoomsDestination(
                                          addLabStudy.branchOfficeDestination
                                            .value
                                        );
                                        swConsultingRoom = false;
                                      "
                                      :disabled="swBranchOffice"
                                      required
                                    ></v-autocomplete>
                                  </validation-provider>
                                </v-col>

                                <v-col>
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Consultorio de destino"
                                    rules="required"
                                  >
                                    <v-autocomplete
                                      return-object
                                      v-model="
                                        addLabStudy.idConsultingRoomDestination
                                      "
                                      :items="consultingRoomsDestination"
                                      :items-text="
                                        consultingRoomsDestination.text
                                      "
                                      :items-value="
                                        consultingRoomsDestination.value
                                      "
                                      :error-messages="errors"
                                      clearable
                                      prepend-icon="mdi-hospital-marker"
                                      label="Consultorio de destino"
                                      no-data-text="Sin consultorios por mostrar"
                                      @change="swDate = false"
                                      :disabled="swConsultingRoom"
                                      required
                                    ></v-autocomplete>
                                  </validation-provider>
                                </v-col>
                                <v-col>
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Doctor de destino"
                                    rules="required"
                                  >
                                    <v-autocomplete
                                      return-object
                                      v-model="
                                        addLabStudy.humanResourceDestination
                                      "
                                      :items="humanResourceList"
                                      :item-text="humanResourceList.text"
                                      :item-value="humanResourceList.value"
                                      :error-messages="errors"
                                      clearable
                                      prepend-icon="mdi-doctor"
                                      label="Doctor de destino"
                                      no-data-text="Sin doctores por mostrar"
                                      :disabled="swDoctor"
                                      required
                                    ></v-autocomplete>
                                  </validation-provider>
                                </v-col>
                              </v-row>
                            </div>
                            <v-row
                              align="center"
                              justify="space-around"
                              class="mb-5"
                            >
                              <v-btn color="secondary" text @click="reset()">
                                Limpiar <v-icon right>mdi-eraser</v-icon>
                              </v-btn>

                              <v-btn
                                color="primary"
                                @click="addStudies()"
                                :disabled="invalid"
                              >
                                Agregar<v-icon right>mdi-plus</v-icon>
                              </v-btn>
                            </v-row>
                          </v-form>
                        </validation-observer> -->
                      </v-container>
                      <v-row>
                        <v-col>
                          <div class="mt-5">
                            <v-container>
                              <v-card v-if="addedStudiesList.length > 0">
                                <v-simple-table dense fixed-header>
                                  <v-data-table :headers="headersStudy" :items="addedStudiesList" :items-per-page="-1"
                                    :footer-props="{
      'items-per-page-text':
        'Elementos por página',
      'items-per-page-all-text': 'Todo',
    }" no-results-text="Sin resultados coincidentes con el búsqueda" loading-text="Cargando..."
                                    no-data-text="Sin resultados disponibles" dense hide-default-footer fixed-header
                                    height="auto">
                                    <template v-slot:[`item.actions`]="{ index, item }">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn icon @click="
      removeStudyAlert(index, item)
      " :disabled="item.disabled">
                                            <v-icon color="error" v-bind="attrs" v-on="on">
                                              mdi-delete
                                            </v-icon>
                                          </v-btn>
                                        </template>
                                        <span v-if="item.disabled">{{
      item.nameStatus
    }}</span>
                                        <span v-if="!item.disabled">
                                          {{
      item.idSpeciality == 4 &&
        item.speciality.toUpperCase() ==
        "DENTAL"
        ? "Cancelar consulta"
        : `Cancelar estudio`
    }}
                                        </span>
                                      </v-tooltip>
                                    </template>
                                  </v-data-table>
                                </v-simple-table>
                              </v-card>
                            </v-container>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-container>
                </template>
              </v-container>
            </v-card-text>

            <v-card-actions id="consulta">
              <v-row align="center" justify="center" class="mt-10 mb-3">
                <v-col class="text-center">
                  <v-btn color="error" plain class="mb-4" @click="changeAction(1)"><v-icon
                      left>mdi-chevron-left</v-icon>Volver
                  </v-btn>
                </v-col>
                <v-col class="text-center">
                  <v-btn color="primary" :disabled="sending || invalid" @click="updateMedicalPractice() || !canFinishConsultation">
                    Editar Consulta
                    <v-icon right>mdi-content-save</v-icon>
                  </v-btn>
                  <!-- @click="updateMedicalPractice()" -->
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>

      <v-dialog v-model="dialog2" persistent max-width="1000">
        <v-card>
          <v-card-title class="text-h6 text-center error--text">
            ¿Desea cancelar este estudio?
          </v-card-title>

          <validation-observer ref="cancelStudy" v-slot="{ invalid }">
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black">
                      Datos generales del paciente
                    </h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field :value="medicalPractice.diagnosticPersonInfo.fullName" label="Paciente"
                      disabled></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field :value="medicalPractice.diagnosticPersonInfo.birthDate" label="Fecha de nacimiento"
                      disabled></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field :value="medicalPractice.genderName" label="Sexo" disabled></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black">
                      Datos generales del estudio
                    </h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field :value="studyToCancel.item.modality" label="Modalidad" disabled></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field :value="studyToCancel.item.modalityStudy" label="Estudio" disabled></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field :value="studyToCancel.item.idStudy" label="Id Estudio" disabled></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <h3 class="font-weight-black primary--text">
                      Accession Number: {{ studyToCancel.item.accessionNumber }}
                    </h3>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <h3 class="font-weight-black mt-5">Motivo</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-form v-model="valid" lazy-validation>
                      <v-row>
                        <v-col @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
                          <validation-provider v-slot="{ errors }" name="Motivo" rules="required">
                            <v-textarea outlined v-model="reason" :value="reason" :error-messages="errors"
                              label="Motivo de cancelación" id="cancellation" required></v-textarea>
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions class="text-center">
              <v-col>
                <v-btn color="error" plain @click="cancelStudy()">
                  <v-icon left>mdi-chevron-left</v-icon> Volver
                </v-btn>
              </v-col>
              <v-col>
                <v-btn :disabled="sending || invalid" color="primary" @click="removeStudy()">
                  Cancelar estudio <v-icon right>mdi-calendar-remove</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </validation-observer>
        </v-card>
      </v-dialog>

      <!-- Consultas-->
      <v-dialog v-model="dialog" persistent max-width="800">
        <v-card>
          <validation-observer ref="consultation" v-slot="{ invalid }">
            <v-card-title class="text-h6 text-center error--text">
              ¿Desea cancelar esta consulta?
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <h3 class="font-weight-black">
                    Datos generales del paciente
                  </h3>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field :value="medicalPractice.diagnosticPersonInfo.fullName" label="Paciente"
                      disabled></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field :value="medicalPractice.diagnosticPersonInfo.birthDate" label="Fecha de nacimiento"
                      disabled></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field :value="medicalPractice.genderName" label="Sexo" disabled></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field :value="studyToCancel.item.idStudy" label="Id Consulta" disabled></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
                    <v-form v-model="valid" lazy-validation>
                      <validation-provider v-slot="{ errors }" name="Motivo" rules="required|min:6">
                        <v-textarea outlined v-model="reason" :value="reason" label="Motivo de la cancelación"
                          id="cancellation" :error-messages="errors" required></v-textarea>
                      </validation-provider>
                    </v-form>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="text-center">
              <v-col>
                <v-btn color="error" plain @click="cancelConsultationModal()">
                  <v-icon left>mdi-chevron-left</v-icon> Volver
                </v-btn>
              </v-col>
              <v-col>
                <v-btn :disabled="sending || invalid" color="primary" @click="removeStudy()">
                  Cancelar consulta <v-icon right>mdi-calendar-remove</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </validation-observer>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import {
  MedicalPracticeRequest,
  ReportPDFRequest,
  EvaluationRequest,
  VitalSignRequest,
  ProductsRequest,
  SpecialityRequest,
  CieRequest,
  EnumRequest,
  StudyModalityRequest,
  ModaltyRequest,
  CalculatorsSomatometryRequest,
} from "@/core/request";
import Sidebar from "@/components/Sidebar.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Datatable from "@/components/Datatable.vue";
import moment from "moment";
import BtnAccion from "@/components/btnAccion.vue";
import { mapActions } from "vuex";
import Loader from "../../components/Loader.vue";
import AutoLogout from "../../components/AutoLogout.vue";
import BranchOfficesList from "../../components/BranchOfficesList.vue";
import ExportImportBtn from "../../components/ExportImportBtn.vue";
import { VueEditor } from "vue2-editor";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { required, max_value, min_value, max } from "vee-validate/dist/rules";

import SpecialitiesTabs from "@/components/appointments/speciality/SpecialitiesTabs.vue";
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientConsultationInfo from "@/app/components/common/patient/PatientConsultationInfo.vue";
import cardioRiskData from "@/app/json/cardioRiskData.json"; 

extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max_value", {
  ...max_value,
  message: "{_field_} no puede exceder de {max}",
});

extend("min_value", {
  ...min_value,
  message: "{_field_} no puede ser menor o igual a 0",
});

extend("max", {
  ...max,
  message: "{_field_} no debe tener más de {length} caracteres",
});

let token = sessionStorage.tokenUser;

export default {
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    BtnAccion,
    Loader,
    AutoLogout,
    BranchOfficesList,
    ExportImportBtn,
    VueEditor,
    ValidationObserver,
    ValidationProvider,
    SpecialitiesTabs,
    PatientInformation,
    PatientConsultationInfo,
  },
  name: "Consultas",
  data: () => ({
    range: "",

    loader: false,
    loader: false,
    encabezado: {
      icono: "mdi-stethoscope",
      texto: "Historial de consultas",
    },
    titleUpdateCons: {
      icono: "mdi-stethoscope",
      texto: "Editar consulta",
    },
    titleConsultation: {
      icono: "mdi-stethoscope",
      texto: "Detalles de consulta",
    },
    headers: [
    // { text: "#", value: "counter", align: "center" },
      { text: "Id Consulta", value: "idConsultation", align: "center" },
      { text: "Id Paciente", value: "idPatient", align: "center" },
      {
        text: "Nombre del paciente",
        value: "fullNamePatient",
        align: "center",
      },
      { text: "Nombre del doctor", value: "doctor", align: "center" },
      {
        text: "Fecha y hora de atención",
        value: "attentionDate",
        align: "center",
      },
      { text: "Acciones", value: "actions", sortable: false, align: "center" },
    ],
    listHisCons: [],
    search: "",
    btnHisConsul: {
      route: "/consultas/pendientes",
      icon: "mdi-stethoscope",
      text: "Consultas pendientes",
      tooltip: "Ver consultas pendientes",
    },
    idBranchOfficeSelected: null,
    cols: "col-md-3 col-xl-3 col-sm-12",
    totalRecords: 0,
    options: {},
    action: 1,

    // ! DATA CONSULTATION DETAILS
    idPatient: "",
    loader: false,
    content: "",
    arrPres: [],
    products: [],
    nameRoute: "ConsultasPendientes",
    paramsRoute: {},
    disabledHeader: false,
    vitalSign: [],
    listSpecialityFromRegister: [],
    panelCalculators: [],
    calculatorsData: [],
    interpretation: [
        {
          scoreRange: "Menos de 7",
          risk: "Riesgo bajo",
          description: "1%",
          minValue: 0,
          maxValue: 6
        },
        {
          scoreRange: "7-11",
          risk: "Riesgo ligeramente elevado",
          description: "4%",
          minValue: 7,
          maxValue: 11
        },
        {
          scoreRange: "12-14",
          risk: "Riesgo moderado",
          description: "17%",
          minValue: 12,
          maxValue: 14
        },
        {
          scoreRange: "15-20",
          risk: "Riesgo alto",
          description: "33%",
          minValue: 15,
          maxValue: 20
        },
        {
          scoreRange: "Más de 20",
          risk: "Riesgo muy alto",
          description: "50%",
          minValue: 21,
          maxValue: 99
        },
      ],
      headersDiabetesResults: [
        {
          text: 'Puntuación total',
          align: 'start',
          value: 'scoreRange',
        },
        { text: 'Riesgo de desarrollar diabetes en los próximos 10 años', value: 'description' },
        { text: 'Interpretación', value: 'risk' },
      ],
      pointsMapping: {
      "ATEL-03": 0,
  "ATEL-04": 2,
  "ATEL-05": 0,
  "ATEL-06": 1,
  "ATEL-07": 2,
  "ATEL-08": 0,
  "ATEL-09": 5,
  "ATEL-10": 0,
  "ATEL-11": 0,
  "ATEL-12": 3,
  "ATEL-13": 5,
  // HIPERPLASIA PROSTATICA mapping
  "ATEL-14": 0,
  "ATEL-15": 1,
  "ATEL-16": 2,
  "ATEL-17": 3,
  "ATEL-18": 4,
  "ATEL-19": 5,
  "ATEL-20": 0,
  "ATEL-21": 1,
  "ATEL-22": 2,
  "ATEL-23": 3,
  "ATEL-24": 4,
  "ATEL-25": 5,
  "ATEL-26": 0,
  "ATEL-27": 1,
  "ATEL-28": 2,
  "ATEL-29": 3,
  "ATEL-30": 4,
  "ATEL-31": 5,
  "ATEL-32": 0,
  "ATEL-33": 1,
  "ATEL-34": 2,
  "ATEL-35": 3,
  "ATEL-36": 4,
  "ATEL-37": 5,
  "ATEL-38": 0,
  "ATEL-39": 1,
  "ATEL-40": 2,
  "ATEL-41": 3,
  "ATEL-42": 4,
  "ATEL-43": 5,
  "ATEL-44": 0,
  "ATEL-45": 1,
  "ATEL-46": 2,
  "ATEL-47": 3,
  "ATEL-48": 4,
  "ATEL-49": 5,
  "ATEL-50": 0,
  "ATEL-51": 1,
  "ATEL-52": 2,
  "ATEL-53": 3,
  "ATEL-54": 4,
  "ATEL-55": 5
    },
      interpretationRanges: [
        { min: 0, max: 6, risk: "1%", interpretation: "Riesgo bajo" },
        {
          min: 7,
          max: 11,
          risk: "4%",
          interpretation: "Riesgo ligeramente elevado",
        },
        { min: 12, max: 14, risk: "17%", interpretation: "Riesgo moderado" },
        { min: 15, max: 20, risk: "33%", interpretation: "Riesgo alto" },
        {
          min: 21,
          max: Infinity,
          risk: "50%",
          interpretation: "Riesgo muy alto",
        },
      ],
    medicalPractice: {
      diagnosticPersonInfo: {
        idMedicalPractice: "",
        // medicalPractice: {
        //   appointment: {
        //     clinicalEvent: {
        //       patient: {
        //         person: {},
        //       },
        //     },
        //     humanResourceOrigin: {
        //       person: {},
        //     },
        //   },
        // },
      },
      treatment: {},
    },
    dateInfo: "",
    registrationDate: "",
    pathologicals: [],
    heredoFamiliar: [],
    disabilityOptions: [],
      patient: {
        hasDisability: null,   
        disabilityType: null,  
      },
    ginecologicos: [],
    genderPatient: "",
    panelHF: [0],
    panelPL: [0],
    panelGO: [0],
    selectedPatient: true,
    idPerson: null,
    isPregnant: null,
    headersProducts: [
      { text: "#", value: "count" },
      { text: "Causes", value: "productKey" },
      { text: "Producto", value: "name" },
      { text: "Descripción", value: "description" },
      { text: "Instrucción", value: "instruction" },
      { text: "Recetada", value: "request", sortable: false },
      { text: "Dispensada", value: "dispensed", sortable: false },
    ],
    headersStudies: [
      { text: "#", value: "count" },
      { text: "Id Estudio", value: "idStudy" },
      { text: "Especialidad", value: "speciality" },
      { text: "Modalidad", value: "modality" },
      { text: "Perfil de estudio", value: "modalityStudy" },
      { text: "Estatus", value: "nameStatus" },
    ],
    listStudies: [],
    cieSelected: [],
    cie: [],
    old: "",
    prescription: true,
    fab: false,
    diagnosticDetails: "",
    subsequent: "",
    hasSubsequent: "",
    consulta: {
      laboratorio: false,
      receta: false,
    },

    // ! DATA CONSULTATION UPDATE
    panelSV: 0,
    inputsVitalSign: [],
    listProductsAdded: [],
    addedStudiesList: [],
    headersStudy: [
      { text: "Id Estudio", value: "idStudy" },
      { text: "Especialidad", value: "speciality" },
      { text: "Modalidad", value: "modality" },
      { text: "Perfil de estudio", value: "modalityStudy" },
      { text: "Estatus", value: "nameStatus" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    profileStudiesList: [],
    modaltiesList: [],
    swModalty: true,
    swProfile: true,
    panelOG: [0],
    product: {},
    idMedicalPractice: null,
    invalidPrescription: false,
    quantity: 0,
    dialog: false,
    dialog2: false,
    oldValidation: 0,
    addLabStudy: [],
    hasPendingSelection: false,
    hasPushedStudies: false,
    studyToCancel: {
      item: {
        modality: "",
        speciality: "",
        idStudy: "",
      },
    },
    sending: false,
    reason: "",
    valid: false,
    pageCount: 0,
    totalCount: 0,
    currentPage: 1,
    itemsPerPage: 10,
    /************************** */
    /** @MaudePallares **/
    patientData: {},
    flagComponentInfo: false,
    /************************** */
  }),
  mounted() {
    this.validBrowserTab();
    this.listAllConsultPending();
  },

  watch: {
  isPregnant(newVal) {
    if (newVal === 0) {
      this.ginecologicos.forEach((item) => {
        item.questions.forEach((question) => {
          if (question.idQuestion === "C-29" || question.idQuestion === "C-30") {
            question.answer = "";
            question.idAnswer = null;
            question.selectedAnswers = [];
          }
        });
      });
    }
  }
},
  computed: {
    filteredCalculators() {
  return this.calculatorsData.filter((calculator) => {
    if (calculator.idCalculator === "ETEL-02" && this.oldValidation < 44) {
      return false;
    }

    if (
      calculator.idCalculator === "ETEL-03" &&
      (this.medicalPractice.genderName === "Femenino" || this.oldValidation < 40)
    ) {
      return false;
    }

    return true;
  });
},
    checkStocks() {
      return `required|numeric|min_value:1|max_value:${this.quantity}`;
    },
    rangeComputed() {
      if (
        this.range === null ||
        this.range === "" ||
        this.range === undefined
      ) {
        return "";
      }
      return `Del ${moment(new Date(this.range.start)).format(
        "DD/MM/YYYY"
      )} al ${moment(new Date(this.range.end)).format("DD/MM/YYYY")}`;
    },
    validData() {
      if (this.range == "" || this.range == null || this.range == undefined) {
        return false;
      }

      this.listAllConsultPending();
      return true;
    },
    agePoints() {
    if (this.oldValidation < 45) {
      return 0;
    } else if (this.oldValidation <= 54) {
      return 2;
    } else if (this.oldValidation <= 64) {
      return 3;
    } else {
      return 4;
    }
  },
  
  imcPoints() {
    const imc = this.findVitalSignValue(3); 
    if (imc < 25) return 0;
    else if (imc < 30) return 1;
    else return 3;
  },

  abdominalPoints() {
  const measure = this.findVitalSignValue(11);
  const gender = this.medicalPractice?.genderName || this.genderPatient;
  if (gender === "Masculino") {
    if (measure < 94) return 0;
    if (measure <= 102) return 3;
    return 4;
  } else if (gender === "Femenino") {
    if (measure < 80) return 0;
    if (measure <= 88) return 3;
    return 4;
  }
  return 0;
},

  totalPoints() {
    const questionPoints = this.filteredCalculators[0].dataQuestions.reduce(
      (sum, question) => {
        const selectedAnswer = question.answerClosed; 
        const points = this.pointsMapping[selectedAnswer] || 0; 
        return sum + points;
      },
      0
    );

    return questionPoints + this.agePoints + this.imcPoints + this.abdominalPoints;
  },

  riskData() {
    return this.interpretationRanges.find(
      (range) => this.totalPoints >= range.min && this.totalPoints <= range.max
    );
  },
  riskPercentage() {
    return this.riskData ? this.riskData.risk : "N/A";
  },
  riskInterpretation() {
    return this.riskData ? this.riskData.interpretation : "N/A";
  },

  hasIncompleteStudies() {
    if (!Array.isArray(this.addLabStudy) || this.addLabStudy.length === 0) {
      return false;
    }
    return this.addLabStudy.some(study => {
      const idSpec = study.speciality?.idSpeciality;
      if (![2,3].includes(idSpec)) return false;  // sólo LAB/IMG
      return !(study.modality?.idModality && study.studyProfile?.idStudyProfile);
    });
  },

  hasIncompleteCalculators() {
    return this.filteredCalculators.some(calc =>
      calc.dataQuestions.some(q => {
        if (q.typeAnswer === 2)    return !q.answerClosed;
        if (q.typeAnswer === 1)    return !q.answerOpen;
        return false;
      })
    );
  },

  canFinishConsultation() {
    return (
      !this.hasIncompleteStudies &&
      !this.hasIncompleteCalculators
    );
  },

  studyValidationMessage() {
    if (!this.hasIncompleteStudies) return '';
    const cnt = this.addLabStudy.filter(study => {
      const idSpec = study.speciality?.idSpeciality;
      const isLabImg = [2,3].includes(idSpec);
      return isLabImg && !(study.modality?.idModality && study.studyProfile?.idStudyProfile);
    }).length;
    return `Hay ${cnt} estudio(s) de laboratorio/imagen incompletos. Verifique modalidad y perfil.`;
  },


  },
  methods: {
    /************************** */
    /* @MaudePallares */

    addStudies(list) {
      this.addLabStudy = list;
    },
    /************************** */
    changePage(page) {
      if (this.currentPage != page) {
        this.currentPage = page;
        this.listAllPagination();
      }
    },
    clearCalendar() {
      if (this.$utilFront.nonEmpty(this.range)) {
        this.range = "";
        this.listAllConsultPending();
      } else {
        this.range = "";
      }
    },
    onEditorInput(html) {
      const plain = html.replace(/<[^>]*>/g, '')
      if (!plain.trim()) {
        this.content = ''
      } else {
        this.content = html
      }
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action === 1) {
        this.flagComponentInfo = false;
        this.action = action;
        if(this.$refs && this.$refs.form){
          this.$refs.form.reset();
        }
        this.resetPresForm();
        this.reset();
        this.listAllConsultPending();
        this.consulta = {
          laboratorio: false,
          receta: false,
        };
      } else if (action == 2) {
        this.loader = true;
        this.action = action;
      } else if (action == 3) {
        this.loader = false;
        this.action = action;
      }
    },
    exportMedicalPractice(typeFile) {
      this.loader = true;
      let fileName = typeFile == 1 ? "Consultas.pdf" : "Consultas.xlsx";

      let params = {
        statusAppointment: 3,
        statusMedicalPractice: 3,
        statusMedicalPracticeList: [3],
        statusAppointmentList: [3, 7, 4],
        speciality: 1,
        idBranchOffice: this.idBranchOfficeSelected != null ? this.idBranchOfficeSelected : this.$utilFront.getIdBranchOffice(),
        typeFile: typeFile,
        fileName: fileName
      };

      if (this.$utilFront.nonEmpty(this.range)) {           
        params.startDate = this.$utilFront.startOfDay(this.range.start);           
        params.finishDate = this.$utilFront.endOfDay(this.range.end);         
      }


      ReportPDFRequest.exportConsultation(params)
        .then((res) => {
          switch (typeFile) {
            case 1: //PDF
              this.$utilFront.openPDF(res.data);
              break;
            case 2: //XLSX
              this.$utilFront.downloadXLSX(res.data, fileName);
              break;
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    listAllConsultPending() {
      this.loader = true;

      let params = {
        statusAppointment: 3,
        statusMedicalPracticeList: [3],
        statusAppointmentList: [3, 7, 4],
        speciality: 1,
        idBranchOffice: this.idBranchOfficeSelected != null ? this.idBranchOfficeSelected: this.$utilFront.getIdBranchOffice()
      };

      if (this.$utilFront.nonEmpty(this.range)) {           
        params.startDate = this.$utilFront.startOfDay(this.range.start);           
        params.finishDate = this.$utilFront.endOfDay(this.range.end);         
      }


      MedicalPracticeRequest.listMedicalPracticeByStatusAndSpeciality(params)
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            let data = res.data.data;
            if (data) {
              data.sort(function (a, b) {
                return new Date(b.attentionDate) - new Date(a.attentionDate);
              });
            }

            this.listHisCons = data.map((list) => {
              let doctorName = " ----";
              if (list.fullNameDoctor != null) {
                doctorName = list.fullNameDoctor;
              } else if (list.nameDoctorCanceled != null) {
                doctorName = list.nameDoctorCanceled;
              }

              let status = this.$utilFront.getMedicalPracticeStatus(
                list.statusMedicalPractice
              );
              this.patientData = {
                idPatient: list.idPatient,
                idMedicalPractice: list.idMedicalPractice,
              };
              return {
                idConsultation: list.idMedicalPractice,
                idAppointmen: list.idAppointment,
                fullNamePatient: list.fullNamePatient,
                doctor: this.$utilFront.nonEmpty(doctorName, "---"),
                dateAppointment: moment(new Date(list.appointmentDate)).format(
                  "DD/MM/YYYY HH:mm"
                ),
                status: list.nameStatus,
                idPatient: list.idPatient,
                idDiagnostic: list.idDiagnostic,
                idHumanResource: list.idHumanResource,
                attentionDate: this.$utilFront.formatDateTime(
                  list.attentionDate
                ),
                cancellationDate:
                  list.cancellationDate != null
                    ? this.$utilFront.formatDateTime(list.cancellationDate)
                    : " ----",
                nameStatusMedical: status,
                statusMedicalPractice: list.statusMedicalPractice,
                idPrescription: list.idPrescription,
                doctorCanceled: this.$utilFront.nonEmpty(
                  list.nameDoctorCanceled,
                  "---"
                ),
              };
            });
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(
              "Sucedio un error al consultar historico",
              "ERROR"
            );
            this.loader = false;
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    getDataPatient(item) {
      this.$router.push({
        name: "DetalleConsulta",
        params: {
          idPatient: item.idPatient,
          idMedicalPractice: item.idConsultation,
        },
      });
    },

    getDataPatientUpdate(item) {
      this.$router.push({
        name: "EditarConsulta",
        params: {
          idPatient: item.idPatient,
          idMedicalPractice: item.idConsultation,
          idAppointment: item.idAppointment,
        },
      });
    },
    getMedicalPracticeDetails(item, type) {
      //TYPE: 1- consulta, 2-ordend e estudio
      this.loader = true;
      this.loader = true;
      const idMedicalPractice = item.idConsultation;
      MedicalPracticeRequest.listMedicalPracticeDetails(
        { idMedicalPractice: idMedicalPractice },
        { headers: { Authorization: token } }
      ).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.loader = false;
          const mpData = res.data.data;
          this.exportToPdf(mpData, type);
        } else if (res.data.code === 401) {
          this.loader = false;
          this.unauthorized();
        }
      });
    },
    exportToPdf(MedicalPracticeData, type) {
      if (MedicalPracticeData) {
        const fileName = `Consulta_${MedicalPracticeData.diagnosticPersonInfo.idMedicalPractice}_${moment(new Date(MedicalPracticeData.diagnosticPersonInfo.startTime)).format("YYYY-MM-DD")}`;
        const data = {
          idConsultation:MedicalPracticeData.diagnosticPersonInfo.idMedicalPractice,
          idDiagnostic: MedicalPracticeData.diagnosticPersonInfo.idDiagnostic,
          fileName: fileName,
        };
        if (type == 1) {
          ReportPDFRequest.downloadConsultation(data);
        } else if (type == 2) {
          ReportPDFRequest.downloadOrderStudy(data).then((res) => {
            if (res.status == 200 && res.data.type != "application/json") {
              this.$utilFront.openPDF(res.data);
            } else {
              this.$utilFront.displayErrorPdf(res.data);
            }
          });
        } else if (type == 3) {
          ReportPDFRequest.downloadClinicalHistory(data).then((res) => {
            if (res.status == 200 && res.data.type != "application/json") {
              this.$utilFront.openPDF(res.data);
            } else {
              this.$utilFront.displayErrorPdf(res.data);
            }
          });
        }
        this.loader = false;
      }
    },

    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllConsultPending();
    },

    exportPDF(item) {
      let url = new URL(location.origin);
      let data = {
        idPrescription: item.idPrescription,
        url: url,
        fileName: "Receta",
      };
      this.loader = true;
      ReportPDFRequest.downloadPrescription(data, this);
    },

    // ! METHODS CONSULTATION DETAILS
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 400;
    },
    getMedicalPractice(item) {
  let idMedicalPractice = item.idConsultation;
  MedicalPracticeRequest.listMedicalPracticeDetails(
    { idMedicalPractice: idMedicalPractice },
    { headers: { Authorization: token } }
  )
    .then((res) => {
      if (res.data.code === 200 && res.data.status === "OK") {
        this.listSpecialityFromRegister = res.data;
        this.flagComponentInfo = true;
        this.medicalPractice = res.data.data;

        this.isPregnant = this.medicalPractice.diagnosticPersonInfo.isPregnant;

        let imssNumber = this.medicalPractice.diagnosticPersonInfo.imssNumber;
        this.medicalPractice.diagnosticPersonInfo.imssNumber =
          imssNumber == null || imssNumber === "" ? "----" : imssNumber;

        this.dateInfo = this.$utilFront.formatDateTime(
          this.medicalPractice.diagnosticPersonInfo.registrationDateMedicalPractice
        );

        this.old = this.$utilFront.obtainAgeWithLabel(
          this.medicalPractice.diagnosticPersonInfo.birthDate
        );

        this.oldValidation = this.$utilFront.obtainAge(
          this.medicalPractice.diagnosticPersonInfo.birthDate
        );


        this.medicalPractice.genderName =
          this.medicalPractice.diagnosticPersonInfo.genderPatient;

        this.products = this.medicalPractice.products.map((p) => {
          return {
            dispensed:
              this.prescription == true ? p.dispensed : "Por dispensar",
            request: p.request,
            name: p.product.name,
            description: p.product.text,
            instruction:
              p.instruction == null || p.instruction === ""
                ? "----"
                : p.instruction,
            productKey: p.product.product_key,
          };
        });

        this.cieSelected = this.medicalPractice.cie10.map((c) => {
          return c.cie10.idCIE10;
        });

        this.cie = this.medicalPractice.cie10.map((c) => {
          return {
            text: c.cie10.key + " - " + c.cie10.name,
            value: c.cie10.idCIE10,
          };
        });

        this.listStudies = this.medicalPractice.studies;

        let templete = "";
        templete += this.medicalPractice.diagnosticPersonInfo.textDiagnostic;
        this.content = templete;

        this.diagnosticDetails =
          this.medicalPractice.diagnosticPersonInfo.diagnosticDetails;
        this.subsequent = this.medicalPractice.subsequent;
        this.hasSubsequent = this.$utilFront.nonEmpty(
          this.medicalPractice.subsequent
        );

        this.idPerson = this.medicalPractice.diagnosticPersonInfo.idPerson;
        this.idPatient = this.medicalPractice.diagnosticPersonInfo.idPatient;

        this.getAntecentsByPerson();
        this.changeAction(2);
        this.getAllDisabilities();


        const evaluationTypes = [9, 10, 11];
        this.getCalculator({ idPerson: this.idPerson, evaluationTypes, idClinicalEvent: this.medicalPractice.diagnosticPersonInfo.idClinicalEvent });

      } else if (res.data.code === 401) {
        this.unauthorized();
      }
    })
    .finally(() => {
      this.getVitalSignByPatient(this.idPatient, idMedicalPractice);
      this.loader = false;
    });
},

    getVitalSignByPatient(idPatient, idMedicalPractice) {
      let params = {
        idMedicalPractice: idMedicalPractice,
      };
      VitalSignRequest.findAllByPatientOrStudyOrMedicalPractice(params).then(
        (res) => {
          if (res.data.code === 200) {
            this.vitalSign = res.data.data.map((vital) => {
              let type = "";
              if (vital.vitalSignType.type === 1) {
                type = "number";
              } else if (vital.vitalSignType.type === 2) {
                type = "text";
              }
              let required = 0;
              if (vital.vitalSignType.required === 1) {
                required = true;
              } else if (vital.vitalSignType.required === 2) {
                required = false;
              }

              return {
                idVitalSignType: vital.vitalSignType.idVitalSignType,
                type: type,
                label: vital.vitalSignType.name,
                suffix: vital.vitalSignType.suffix,
                status: vital.vitalSignType.status,
                required: required,
                value: vital.description,
                idVitalSigns: vital.idVitalSigns,
              };
            });

          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        }
      );
    },
    getCalculator(payload) {
  CalculatorsSomatometryRequest.getCalculatorsSomatometry(payload)
    .then((res) => {

      this.calculatorsData = res.data;

      this.calculatorsData.forEach((calculator) => {
        calculator.dataQuestions.forEach((question) => {
          if (question.typeAnswer === 2 && question.idAnswer) {
            question.answerClosed = question.idAnswer; 
          }
        });
      });

    })
    .catch((error) => {
      console.error("Error:", error);
    });
},
    getAntecentsByPerson() {
      this.pathologicals = [];
      this.loader = true;

      EvaluationRequest.listByPersonAndType({
        type: 2,
        idPerson: this.idPerson,
      })
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.pathologicals = data;
            this.panePL = data.map((it, i) => {
              return i;
            });
          }
        })
        .finally(() => {
          this.heredoFamiliar = [];

          EvaluationRequest.listByPersonAndType({
            type: 3,
            idPerson: this.idPerson,
          })
            .then((res) => {
              let { data, response, message } = res.data;
              if (response) {
                this.heredoFamiliar = data;
                this.panelHF = data.map((it, i) => {
                  return i;
                });
              }
            })
            .finally(() => {
              if (this.medicalPractice.genderName.toUpperCase() == "FEMENINO") {
                EvaluationRequest.listByPersonAndType({
                  type: 4,
                  idPerson: this.idPerson,
                  idMedicalPractice: this.medicalPractice.diagnosticPersonInfo.idMedicalPractice,
                }).then((res) => {
                  let { data, response, message } = res.data;

                  if (response) {
                    this.ginecologicos = data;

                    this.panelGO = data.map((it, i) => {
                      return i;
                    });
                  } else {
                    this.ginecologicos = [];
                  }
                });
                this.loader = false;
              }
            });
        });
    },

    // ! METHODS UPDATE CONSULTATION
    async saveQuantity(product) {
      this.quantity = 0;
      let data = await this.productSelectedList(product.idProduct.value);
      this.quantity = data[0].quantity;
    },
    async productSelectedList(products) {
      return this.productsList.filter((product) => product.value === products);
    },
    validBrowserTab() {
      this.validTab();
    },
    remove(item) {
      const index = this.cieSelected.indexOf(item.value);
      if (index >= 0) this.cieSelected.splice(index, 1);
    },
    getSpecialities() {
      this.specialitiesList = [];
      SpecialityRequest.allSpeciality().then((res) => {
        let { data } = res.data;

        if (this.$utilFront.nonEmptyList(data)) {
          this.specialitiesList = data
            .map((obj) => {
              return { text: obj.name, value: obj.idSpeciality };
            })
            .filter((obj) => obj.value != 1);
        }
      });
    },
    validatePresForm() {
      return this.$refs.fmPres.validate();
    },
    resetPresForm() {
      if (this.consulta.receta == true) {
        this.product = {};
        this.quantity = 0;
        this.$refs.fmPres.reset();
      }
    },
    getMedicalPracticeUpdate(idConsultation) {
  this.loader = true;
  const idMedicalPractice = idConsultation;
  this.idMedicalPractice = idConsultation;
  MedicalPracticeRequest.listMedicalPracticeDetails({
    idMedicalPractice: idMedicalPractice,
  })
    .then((res) => {
      if (res.data.code === 200 && res.data.status === "OK") {
        this.listSpecialityFromRegister = res.data;
        this.medicalPractice = res.data.data;
        this.flagComponentInfo = true;
        this.prescription =
          this.medicalPractice.prescription.dispensingDate == null
            ? false
            : true;
            this.isPregnant = this.medicalPractice.diagnosticPersonInfo.isPregnant;

        let imssNumber = this.medicalPractice.diagnosticPersonInfo.imssNumber;
        this.medicalPractice.diagnosticPersonInfo.imssNumber =
          imssNumber == null || imssNumber === "" ? "----" : imssNumber;

        this.dateInfo = this.$utilFront.formatDateTime(
          this.medicalPractice.diagnosticPersonInfo.registrationDateMedicalPractice
        );
        this.registrationDate = this.medicalPractice.diagnosticPersonInfo.registrationDateMedicalPractice;

        this.old = this.$utilFront.obtainAgeWithLabel(
          this.medicalPractice.diagnosticPersonInfo.birthDate
        );

        this.oldValidation = this.$utilFront.obtainAge(
          this.medicalPractice.diagnosticPersonInfo.birthDate
        );

        this.medicalPractice.diagnosticPersonInfo.birthDate =
          moment(
            new Date(this.medicalPractice.diagnosticPersonInfo.birthDate)
          )
            .locale("es")
            .format("DD/MM/YYYY") || "---";

        this.medicalPractice.genderName = this.medicalPractice.diagnosticPersonInfo.genderPatient;

        this.products = this.medicalPractice.products.map((p) => {
          const description = `${p.product.name}, ${p.product.text}`;
          return {
            dispensed: p.dispensed,
            request: p.request,
            name: p.product.name,
            productKey: p.product.product_key,
            description: description,
          };
        });
        this.listProductsAdded = this.medicalPractice.products.map((p) => {
          const description = `${p.product.name}, ${p.product.text}`;
          return {
            dispensed: p.dispensed,
            request: p.request,
            name: description,
            description: description,
            product_key: p.product.product_key,
            value: p.product.idProduct,
            instruction:
              p.instruction == null || p.instruction === ""
                ? "----"
                : p.instruction,
          };
        });

        this.productsList.forEach((value, index, array) => {
          this.listProductsAdded.forEach((value1, index1, array1) => {
            if (value.value === value1.value) {
              value.disabled = true;
              value.request = value1.request;
            }
          });
        });

        this.addedStudiesList = this.medicalPractice.studies.map((s) => {
          if (!s.dentalConsultation) {
            if (
              s.status == 1 ||
              s.status == 9 ||
              s.status == 10 ||
              s.status == 11
            ) {
              s.disabled = false;
            } else {
              s.disabled = true;
            }
          } else {
            if (s.status == 1 || s.status == 2 || s.status == 6) {
              s.disabled = false;
            } else {
              s.disabled = true;
            }
          }
          return s;
        });

        this.cieSelected = this.medicalPractice.cie10.map((c) => {
          return c.cie10.idCIE10;
        });

        let templete = "";
        templete += this.medicalPractice.diagnosticPersonInfo.textDiagnostic;

        this.content = templete;

        this.diagnosticDetails = this.medicalPractice.diagnosticPersonInfo.diagnosticDetails;
        this.subsequent = this.medicalPractice.subsequent;
        this.hasSubsequent = this.$utilFront.nonEmpty(this.medicalPractice.subsequent);

        this.idPerson = this.medicalPractice.diagnosticPersonInfo.idPerson;
        this.idPatient = this.medicalPractice.diagnosticPersonInfo.idPatient;

        const evaluationTypes = [9, 10, 11];
        this.getCalculator({ idPerson: this.idPerson, evaluationTypes, idClinicalEvent: this.medicalPractice.diagnosticPersonInfo.idClinicalEvent });

        this.getAntecentsByPerson();
        this.changeAction(3);
        this.getAllDisabilities();
        this.hasPushedStudies = false;
      } else if (res.data.code === 401) {
        this.unauthorized();
      }
    })
    .finally(() => {
      this.getVitalSignByPatientUpdate(
        this.idPatient,
        this.idMedicalPractice
      );
      this.loader = false;
    });
},
    getVitalSignByPatientUpdate(idPatient, idMedicalPractice) {
      let postData = {
        idMedicalPractice: idMedicalPractice,
      };
      VitalSignRequest.findAllByPatientOrStudyOrMedicalPractice(postData)
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.inputsVitalSign = res.data.data.map((input) => {
              let type = "";
              if (input.vitalSignType.type === 1) {
                type = "number";
              } else if (input.vitalSignType.type === 2) {
                type = "text";
              }

              let required = 0;
              if (input.vitalSignType.required === 1) {
                required = true;
              } 
              if (input.vitalSignType.name === "Estado de peso corporal") {
                required = true;
              }
              else if (input.vitalSignType.required === 2) {
                required = false;
              }

              return {
                idVitalSignType: input.vitalSignType.idVitalSignType,
                type: type,
                label: input.vitalSignType.name,
                suffix: input.vitalSignType.suffix,
                status: input.vitalSignType.status,
                required: required,
                value: input.description,
                idVitalSigns: input.idVitalSigns,
              };
            });

            this.vitalSign = res.data.data.map((values) => {
              return {
                idVitalSigns: values.idVitalSigns,
                description: values.description,
                idVitalSignType: values.vitalSignType.idVitalSignType,
                typeName: values.vitalSignType.name,
                suffix: values.vitalSignType.suffix,
              };
            });
          } else if (
            res.data.code === 400 &&
            res.data.status === "BAD_REQUEST"
          ) {
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        })
        .finally(() => {
          // this.changeValidation(this.oldValidation);
          
        });
    },
    getProducts(item) {
      this.loader = true;
      let idConsultation = item.idConsultation;
      let idBranchOffice = this.$utilFront.getIdBranchOffice();
      ProductsRequest.listAllProductsWiExistence({
        idBranchOffice: idBranchOffice,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.productsList = res.data.data.map((product) => {
              const description = `${product.name}, ${product.text}`;
              return {
                text:
                  product.product_key +
                  " - " +
                  product.name +
                  " " +
                  product.text,
                value: product.idProduct,
                disabled: false,
                description: product.text,
                name: description,
                quantity: product.quantityInStock,
                product_key: product.product_key,
                request: 0,
                instruction: "",
                productName: product.name,
              };
            });
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        })
        .then(() => {
          this.getCieCatalogue();
        })
        .finally(() => {
          this.getMedicalPracticeUpdate(idConsultation);
          this.getSpecialities();
          this.loader = false;
        });
    },
    // listStudyProfileByModality(idModality) {
    //   StudyModalityRequest.listStudyModalityByModalty({
    //     modality: { idModality: idModality },
    //   }).then((res) => {
    //     if (res.data.code === 200 && res.data.status === "OK") {
    //       this.profileStudiesList = res.data.data.map((profile) => {
    //         let acronym = "";
    //         if (this.$utilFront.nonEmpty(profile.acronym)) {
    //           acronym = `${profile.acronym} -`;
    //         }
    //         let nameProfile = `${acronym} ${profile.name}`;
    //         return {
    //           text: nameProfile,
    //           value: profile.idStudyModality,
    //         };
    //       });
    //     } else if (res.data.code === 401) {
    //       this.unauthorized();
    //     } else {
    //       this.profileStudiesList = [];
    //       this.addLabStudy.idStudyModality = null;
    //     }
    //   });
    // },
    // listModaltyBySpecialty(idSpeciality) {
    //   ModaltyRequest.listModaltyBySpecialty({
    //     speciality: { idSpeciality: idSpeciality },
    //   })
    //     .then((res) => {
    //       if (res.data.code === 200 && res.data.status === "OK") {
    //         this.modaltiesList = res.data.data.map((modalty) => {
    //           let acronym = "";
    //           if (this.$utilFront.nonEmpty(modalty.acronym)) {
    //             acronym = `${modalty.acronym} -`;
    //           }
    //           let nameProfile = `${acronym} ${modalty.name}`;
    //           return {
    //             text: nameProfile,
    //             value: modalty.idModality,
    //           };
    //         });
    //       } else if (res.data.code === 401) {
    //         this.unauthorized();
    //       } else {
    //         this.modaltiesList = [];
    //       }
    //     })
    //     .finally(() => {
    //       this.profileStudiesList = [];
    //     });
    // },
    calculateIMC() {
      let talla = 0;

      let imc = 0;

      let clasificacion = "";

      if (this.oldValidation >= 18) {
        if (this.vitalSign[0].description) {
          talla = this.vitalSign[0].description / 100;
        }

        if (this.vitalSign[1].description) {
          imc = this.vitalSign[1].description / Math.pow(talla, 2);

          imc = parseFloat(imc).toFixed(2);
          if (imc < parseFloat("18.5").toFixed(2)) {
            clasificacion = "Insuficiencia ponderal";
          } else if (
            imc >= parseFloat("18").toFixed(2) &&
            imc < parseFloat("25").toFixed(2)
          ) {
            clasificacion = "Normal";
          } else if (
            imc >= parseFloat("25").toFixed(2) &&
            imc < parseFloat("30").toFixed(2)
          ) {
            clasificacion = "Sobrepeso";
          } else if (
            imc >= parseFloat("30").toFixed(2) &&
            imc < parseFloat("35").toFixed(2)
          ) {
            clasificacion = "Obesidad tipo I";
          } else if (
            imc >= parseFloat("35").toFixed(2) &&
            imc < parseFloat("40").toFixed(2)
          ) {
            clasificacion = "Obesidad tipo II";
          } else if (imc >= parseFloat("40").toFixed(2)) {
            clasificacion = "Obesidad tipo III";
          }

          this.vitalSign[2].description = parseFloat(imc).toFixed(2);
          this.vitalSign[7].description = clasificacion;
        }
      }
    },
    changeValidation(old) {
      for (const key in this.inputsVitalSign) {
        if (old < 18) {
          if (this.inputsVitalSign[key].label === "IMC") {
            this.inputsVitalSign[key].required = false;
          }
          if (this.inputsVitalSign[key].label === "Estado de peso corporal") {
            this.inputsVitalSign[key].required = false;
          }
        } else if (old >= 18) {
          if (this.inputsVitalSign[key].label === "IMC") {
            this.inputsVitalSign[key].required = true;
          }
          if (this.inputsVitalSign[key].label === "Estado de peso corporal") {
            this.inputsVitalSign[key].required = true;
          }
        }
      }
    },

    addProductPrescription() {
      if (this.validatePresForm()) {
        /*let addProduct = {
          instruction: this.product.instruction, 
          request: this.product.request, 
          description: this.product.idProduct.description, 
          text: this.product.idProduct.text,
          value: this.product.idProduct.value
        }*/
        //this.addedProductList.push(addProduct);
        this.productsList.forEach((value, index, array) => {
          if (value.value === this.product.idProduct.value) {
            value.disabled = true;
            value.request = this.product.request;
            value.quantity =
              parseInt(value.quantity) - parseInt(this.product.request);
            value.instruction = this.product.instruction;
            value.name = this.product.idProduct.name;
          }
        });
        this.listAddedProducts(
          this.product.idProduct.value,
          this.product.request
        );
        this.product = {};
        this.quantity = 0;
        this.resetPresForm();
        this.$refs.observer.reset();
      }
    },
    listAddedProducts(idProduct, request) {
      let productSelected = {};
      productSelected = this.productsList.find((prod) => {
        return prod.value === idProduct;
      });
      this.listProductsAdded.push(productSelected);
    },
    deleteProductAdded(idProduct, item) {
      let exited = false;
      let i = this.listProductsAdded.findIndex(
        (index) => index.value === idProduct
      );
      let j = this.listProductsAdded.findIndex((i) => i.value === idProduct);
      this.productsList.forEach((value, index, array) => {
        if (value.value === idProduct) {
          exited = true;
          value.quantity = parseInt(value.quantity) + parseInt(item.request);
          value.disabled = false;
        }
      });
      if (j > -1) this.listProductsAdded.splice(j, 1);
      this.$utilFront.notifications("Producto eliminado correctamente", "INFO");
      if (!exited) {
        let products = {
          text: item.product_key + " - " + item.description,
          value: item.value,
          disabled: false,
          description: item.description,
          name: item.description,
          quantity: parseInt(item.request),
          product_key: item.product_key,
          request: 0,
          instruction: "",
          productName: item.name,
        };
        this.productsList.push(products);
      }
    },
    reset() {
      this.addedStudiesList = [];
      if (this.consulta.laboratorio == true) {
        this.addLabStudy = [];
        // this.$refs.fmEst.reset();
      }
    },
    validate() {
      return this.$refs.form.validate();
    },
    // addStudies() {
    //   if (this.validate()) {
    //     let study = {};
    //     if (
    //       this.addLabStudy.speciality.value == 2 ||
    //       this.addLabStudy.speciality.value == 3
    //     ) {
    //       study = {
    //         idModalityStudy: this.addLabStudy.idStudyModality.value,
    //         modalityStudy: this.addLabStudy.idStudyModality.text,
    //         idModality: this.addLabStudy.modalty.value,
    //         modality: this.addLabStudy.modalty.text,
    //         idSpeciality: this.addLabStudy.speciality.value,
    //         speciality: this.addLabStudy.speciality.text,
    //         idStudy: null,
    //         nameStatus: "----",
    //         cancelStudy: false,
    //         idStudy: "----",
    //       };
    //     } else {
    //       study = {
    //         idModalityStudy: null,
    //         modalityStudy: "N/A",
    //         idModality: null,
    //         modality: "N/A",
    //         idSpeciality: this.addLabStudy.speciality.value,
    //         speciality: this.addLabStudy.speciality.text,
    //         idStudy: null,
    //         nameStatus: "----",
    //         cancelStudy: false,
    //         idStudy: "----",
    //       };
    //     }

    //     this.addedStudiesList.push(study);
    //     this.addLabStudy = {};
    //     this.reset();
    //     this.$refs.cancelStudy.reset();
    //   }
    // },
    removeStudy() {
      if (!this.sending) {
        this.sending = true;

        if (
          this.studyToCancel.item.idStudy == null ||
          this.studyToCancel.item.idStudy == "----"
        ) {
          this.addedStudiesList.splice(this.studyToCancel.index, 1);
        } else {
          this.studyToCancel.item.cancelStudy = true;
          this.studyToCancel.item.disabled = true;
          this.studyToCancel.item.reason = this.reason;
          this.addedStudiesList[
            this.studyToCancel.index
          ] = this.studyToCancel.item;
        }
        this.reason = "";
        this.dialog2 = false;
        this.dialog = false;
        this.sending = false;
      }
    },
    removeStudyAlert(index, item) {
      if (item.idStudy == null || item.idStudy == "----") {
        this.addedStudiesList.splice(index, 1);
      } else {
        (this.studyToCancel.index = index), (this.studyToCancel.item = item);
        if (
              item.idSpeciality !== 1 &&
              item.idSpeciality !== 4 &&
              item.idSpeciality !== 5 &&
              item.idSpeciality !== 6 &&
              item.idSpeciality !== 7 &&
              item.idSpeciality !== 9
            ) {
          this.dialog2 = true;
        } else {
          this.dialog = true;
        }
      }
    },
    getCieCatalogue() {
      this.loader = true;
      CieRequest.listAllCie()
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.cie = res.data.data.map((data) => {
              let cieText = `${data.key} - ${data.name}`;
              return {
                value: data.idCIE10,
                text: cieText,
              };
            });
          }0 
        })
        .finally(() => {
          this.loader = false;
        });
    },
    cancelConsultationModal() {
      this.reason = "";
      this.$refs.consultation.reset();
      this.dialog = false;
    },
    cancelStudy() {
      this.reason = "";
      this.$refs.cancelStudy.reset();
      this.dialog2 = false;
    },
    updateMedicalPractice() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          this.$utilFront.notifications(
            "Verifique que los campos requeridos no esten vacíos",
            "ERROR"
          );
          return;
        }

        if (this.hasPendingSelection) {
      this.$utilFront.notifications(
        'Completa la cita o limpia los campos para editar la consulta.',
        "ERROR"
      );
      return;
    } 
        
    if (this.consulta.receta) {
      const { idProduct, request, instruction } = this.product;
      if (idProduct || request || instruction) {
        this.$utilFront.notifications(
         ' Tienes un medicamento por agregar. Limpia los campos antes de finalizar.',
          "ERROR"
        );
        return;
      }
    }
        
    if (this.consulta.laboratorio) {
      const specTabs = this.$refs.specTabs;
      const formSpec = specTabs?.$refs.formSpec;
      const m = formSpec?.model || {};
      if (m.especialityAppointment?.idSpeciality) {
        this.$utilFront.notifications(
          'Completa la cita o limpia los campos para editar la consulta.',
          'ERROR'
        );
        return;
      }
    }


    if (this.hasIncompleteStudies) {
      this.$utilFront.notifications(this.studyValidationMessage, 'ERROR');
      return;
    }

        if (!this.loader) {
          this.loader = true;
          const idMedicalPractice = this.idMedicalPractice;

          const calculatorsPayload = {
  calculators: this.calculatorsData.map((calculator) => {
    let dataQuestions = calculator.dataQuestions
      .filter((question) => question.answerClosed)
      .map((question) => ({
        idQuestion: question.idQuestion,
        idAnswer: question.answerClosed,
      }));

    return {
      idCalculator: calculator.idCalculator,
      score: this.getCalculatorScore(calculator),
      dataQuestions,
    };
  }),

  idPerson: this.idPerson,
  appointments: this.medicalPractice.diagnosticPersonInfo.appointmentIds || null,
  idClinicalEvent: this.medicalPractice.diagnosticPersonInfo.idClinicalEvent || null,
  idBranchOffice: this.$utilFront.getIdBranchOffice(),
};


          if (
            !calculatorsPayload.calculators.some(
              (calc) => calc.dataQuestions.length
            )
          ) {
            this.$utilFront.notifications(
              "Debe completar todas las calculadoras con respuestas.",
              "ERROR"
            );
            this.sending = false;
            this.loader = false;
            return;
          }

          CalculatorsSomatometryRequest.editCalculatorsSomatometry(
            calculatorsPayload
          )
            .catch(() => {
              this.$utilFront.notifications(
                "Ocurrió un error al editar la consulta.",
                "ERROR"
              );
            });

          let objVitalSign = [];
          for (let key in this.vitalSign) {
            if (this.vitalSign[key].description != null) {
              let arrVital = {
                description: this.vitalSign[key].description,
                idVitalSigns: this.vitalSign[key].idVitalSigns,
                vitalSignType: {
                  idVitalSignType: this.vitalSign[key].idVitalSignType,
                },
              };
              objVitalSign.push(arrVital);
            }
          }
          const postVitalSign = {
            patient: { idPatient: this.idPatient },
            vitalSigns: objVitalSign,
          };

          let evaluations = undefined;

          if (this.$utilFront.nonEmptyList(this.ginecologicos)) {
            evaluations = this.pathologicals.concat(
              this.heredoFamiliar,
              this.ginecologicos
            );
          } else {
            evaluations = this.pathologicals.concat(this.heredoFamiliar);
          }

          let evaluation = {
            evaluations: evaluations,
            idPerson: this.idPerson,
            disability: this.patient.hasDisability === '1' ? this.patient.disabilityType : 1 
          };

          let listProducts = this.listProductsAdded.map((p) => {
            return {
              request: p.request,
              instructions: p.instruction,
              product: {
                idProduct: p.value,
              },
            };
          });

          this.prescriptionText = {
            prescription: {
              idPrescription: this.medicalPractice.prescription.idPrescription,
              diagnostic: {
                textDiagnostic: this.content,
                diagnosticDetails: this.diagnosticDetails,
              },
            },
            products: listProducts,
          };

         /*  if (this.$utilFront.nonEmptyList(this.addLabStudy)) {
            for (let key in this.addLabStudy) {
              let objStudy = {
                idStudy:
                  this.addLabStudy[key].idStudy === undefined ||
                    this.addLabStudy[key].idStudy === "----"
                    ? ""
                    : this.addLabStudy[key].idStudy,
                idSpeciality: this.addLabStudy[key].speciality.idSpeciality,
                speciality: this.addLabStudy[key].speciality.name,
                idModality: this.addLabStudy[key].modality.idModality,
                modality: this.addLabStudy[key].modality.name,
                idModalityStudy: this.addLabStudy[key].studyProfile
                  .idStudyProfile,
                modalityStudy: this.addLabStudy[key].studyProfile.name,
                status: 1,
                nameStatus: "Por comenzar",
                cancelStudy: false,
                accessionNumber: "031",
                dentalConsultation: false,
                disabled: false,
              };
              this.addedStudiesList.push(objStudy);
            }
          } */

          if (!this.hasPushedStudies && this.$utilFront.nonEmptyList(this.addLabStudy)) {
  for (let key in this.addLabStudy) {
    const objStudy = {
      idStudy: this.addLabStudy[key].idStudy === undefined || this.addLabStudy[key].idStudy === '----' ? '' : this.addLabStudy[key].idStudy,
      idSpeciality: this.addLabStudy[key].speciality.idSpeciality,
      speciality: this.addLabStudy[key].speciality.name,
      idModality: this.addLabStudy[key].modality.idModality,
      modality: this.addLabStudy[key].modality.name,
      idModalityStudy: this.addLabStudy[key].studyProfile.idStudyProfile,
      modalityStudy: this.addLabStudy[key].studyProfile.name,
      status: 1,
      nameStatus: 'Por comenzar',
      cancelStudy: false,
      accessionNumber: '031',
      dentalConsultation: false,
      disabled: false,
    };
    this.addedStudiesList.push(objStudy);
  }
  this.hasPushedStudies = true; 
  this.addLabStudy = [];        
}

          let study = null;
          let arrStudies = [];
          if (this.$utilFront.nonEmptyList(this.addedStudiesList)) {
            for (let key in this.addedStudiesList) {
              let objStudy = {
                idStudy:
                  this.addedStudiesList[key].idStudy === "----"
                    ? ""
                    : this.addedStudiesList[key].idStudy,
                speciality: this.addedStudiesList[key].idSpeciality,
                idBranchOffice: this.$utilFront.getIdBranchOffice(),
                priorityStudy: this.addedStudiesList[key].priorityStudy,
                studyModality: {
                  idStudyModality: this.addedStudiesList[key].idModalityStudy,
                },
                appointment: null,
                cancelStudy: this.addedStudiesList[key].cancelStudy,
                reason: this.addedStudiesList[key].reason,
              };
              arrStudies.push(objStudy);
            }
            study = { study: arrStudies };
          }

          let treatment = {
            treatment: this.medicalPractice.treatment.treatment,
            idTreatment: this.medicalPractice.treatment.idTreatment,
          };

          let updateMedical = {
            idMedicalPractice: idMedicalPractice,
            idDiagnostic: this.medicalPractice.diagnosticPersonInfo
              .idDiagnostic,
            vitalSigns: postVitalSign,
            evaluation: evaluation,
            prescriptionList: this.prescriptionText,
            studies: study,
            diagnosticCIE10List: this.cieSelected,
            treatment: treatment,
            subsequent: this.subsequent,
            isPregnant: this.isPregnant
          };
          MedicalPracticeRequest.updateMedicalPractice(updateMedical)
            .then((res) => {
              if (res.data.code === 200 && res.data.status === "OK") {
                this.$utilFront.notifications(
                  "Consulta modificada correctamente.",
                  "SUCCESS"
                );
                this.addedStudiesList = [];
                this.listAllConsultPending();
                this.changeAction(1);
              } else {
                if (typeof res.data.data == "string") {
                  this.$utilFront.notifications(
                    "Error al modificar: " + res.data.data,
                    "ERROR"
                  );
                } else {
                  this.$utilFront.notifications(
                    "Error al modificar la consulta",
                    "ERROR"
                  );
                }
              }
            })
            .finally(() => {
              this.loader = false;
            });
        }

        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },
    cancelConsultation() {
      if (!this.isLoading) {
        if (this.$refs.form.validate()) {
          this.isLoading = true;
          this.dialog2 = false;
          let postID = {
            reason: this.reason,
            medicalPractice: {
              idMedicalPractice: this.studyToCancel.item.idStudy,
            },
          };
          MedicalPracticeRequest.cancelMedicalPractice(postID)
            .then((res) => {
              if (res.data.data) {
                if (res.data.code === 200 && res.data.status === "OK") {
                  this.$utilFront.notifications(
                    "Estudio cancelado correctamente",
                    "SUCCESS"
                  );
                } else if (res.data.code === 401) {
                  this.unauthorized();
                } else {
                  this.$utilFront.notifications(
                    "Sucedio un error al cancelar el estudio",
                    "ERROR"
                  );
                }
              }
            })
            .finally(() => {
              this.isLoading = false;
              this.listAllConsultPending();
            });
        }
      }
    },
    getAgePoints() {
    const age = this.oldValidation || 0;
    if (age < 45) {
      return 0;
    } else if (age <= 54) {
      return 2;
    } else if (age <= 64) {
      return 3;
    } else {
      return 4;
    }
  },

  getImcPoints() {
    const imc = parseFloat(this.vitalSign[3]) || 0;
    if (imc < 25) {
      return 0;
    } else if (imc < 30) {
      return 1;
    } else {
      return 3;
    }
  },

  getAbdominalPoints() {
    const measure = this.findVitalSignValue(11);
    const gender = this.genderName || "X";

    if (gender === "Masculino") {
      if (measure < 94) {
        return 0;
      } else if (measure <= 102) {
        return 3;
      } else {
        return 4;
      }
    } else if (gender === "Femenino") {
      if (measure < 80) {
        return 0;
      } else if (measure <= 88) {
        return 3;
      } else {
        return 4;
      }
    } else {
      return 0;
    }
  },

getCalculatorPoints(calculator) {
    const questionPoints = calculator.dataQuestions.reduce((sum, question) => {
      const selectedAnswerId = question.answerClosed;
      const points = this.pointsMapping[selectedAnswerId] || 0;
      return sum + points;
    }, 0);

    let extras = 0;
    
    if (calculator.name === "ESCALA FINDRISC") {
      extras = this.agePoints + this.imcPoints + this.abdominalPoints;
    }
   

    return questionPoints + extras;
  },
  getRiskInterpretation(calculator) {
    const total = this.getCalculatorPoints(calculator);

    const foundRange = this.interpretationRanges.find(
      (range) => total >= range.min && total <= range.max
    );

    if (!foundRange) {
      return {
        riskPercentage: "N/A",
        riskInterpretation: "N/A"
      };
    }

    return {
      riskPercentage: foundRange.risk,
      riskInterpretation: foundRange.interpretation
    };
  },

  getHiperplasiaInterpretation(calculator) {
    const total = this.getCalculatorPoints(calculator);

    if (total >= 1 && total <= 7) {
      return "Leve";
    } else if (total >= 8 && total <= 19) {
      return "Moderada";
    } else if (total >= 20) {
      return "Severa";
    }

    return "N/A";
  },
  getCardioRiskForCalculator(calculator) {
  if (calculator.idCalculator !== "ETEL-02") return 0;

  let isSmoker = false;
  const question = calculator.dataQuestions.find(
    (q) => q.idQuestion === "QTEL-01" 
  );
  if (question && question.answerClosed === "ATEL-01") {
    isSmoker = true;
  }

  let genero = (this.medicalPractice.genderName  === "Masculino") ? "hombres" : "mujeres";


  const edadRange = this.getAgeRange(this.oldValidation);

  const rawPressure = this.findVitalSignValue(7) || 120; 
  const pKey = this.normalizePressure(rawPressure);

  const rawIMC = this.findVitalSignValue(3) || 20; 
  const imcKey = this.normalizeImc(rawIMC);

  const generoObj = cardioRiskData.datos_generales.find(
    (item) => item.genero === genero
  );
  if (!generoObj) return 0;

  const edadObj = generoObj.datos.find((d) => d.edad === edadRange);
  if (!edadObj) return 0;

  const presionObj = edadObj.presion_arterial.find((pa) => pa.valor === pKey);
  if (!presionObj) return 0;

  const imcObj = presionObj.IMC[imcKey];
  if (!imcObj) return 0;

  const smokeKey = isSmoker ? "fumadoras" : "no_fumadoras";
  const finalValue = imcObj[smokeKey];
  if (finalValue === undefined) return 0;

  return finalValue;
},


    getAgeRange(age) {
      if (age >= 70 && age <= 74) return "70-74";
      if (age >= 65 && age <= 69) return "65-69";
      if (age >= 60 && age <= 64) return "60-64";
      if (age >= 55 && age <= 59) return "55-59";
      if (age >= 50 && age <= 54) return "50-54";
      if (age >= 45 && age <= 49) return "45-49";
      if (age >= 40 && age <= 44) return "40-44";
      return "40-44"; 
    },
    normalizePressure(p) {
      if (p < 130) return 120;
      if (p < 150) return 140;
      if (p < 170) return 160;
      return 180; 
    },
    normalizeImc(imc) {
      if (imc < 22) return "20";
      if (imc < 27) return "25";
      if (imc < 32) return "30";
      return "35";
    },
    findVitalSignValue(typeId) {
  if (!this.vitalSign || !Array.isArray(this.vitalSign)) {
    console.error("vitalSign no está definido o no es un array.");
    return 0;
  }

  const vs = this.vitalSign.find(
    (item) =>
      item.idVitalSignType === typeId ||
      item.vitalSignType?.idVitalSignType === typeId 
  );

  return vs ? parseFloat(vs.description || vs.value) || 0 : 0;
},
  getCalculatorScore(calculator) {
 

  if (calculator.idCalculator === "ETEL-02") {
  
    return this.getCardioRiskForCalculator(calculator);
  } else {
    
    return this.getCalculatorPoints(calculator);
  }
},
getAllDisabilities() {
  EnumRequest.listAllDisability()
    .then((response) => {
      const { code, status, data } = response.data;
      if (code === 200 && status === "OK") {

        this.disabilityOptions = data.filter(
          (item) => item.value !== 1
        );
      } else {
        this.disabilityOptions = [];
      }
    })
    .catch((error) => {
      console.error("Error cargando discapacidades:", error);
      this.disabilityOptions = [];
    });
},
onPatientLoaded(fullData) {
  this.patient = fullData;
  
  if (this.patient.person?.disability === null) {
    this.patient.hasDisability = ""; 
    this.patient.disabilityType = null;
  } else if (this.patient.person?.disability !== 1) {
    this.patient.hasDisability = "1";
    this.patient.disabilityType = this.patient.person.disability;
  } else {
    this.patient.hasDisability = "0";
    this.patient.disabilityType = null;
  }
},
handlePendingSelection(pending){
    const hasSomething = !!(
      pending &&
      (
        (pending.especialityAppointment && pending.especialityAppointment.idSpeciality) ||
        pending.modalityAppointment ||
        (pending.studyProfileAppointment && pending.studyProfileAppointment.idStudyModality)
      )
    );
    this.hasPendingSelection = hasSomething;
  },

addStudies(list) {
    this.addLabStudy = [...list];
    this.hasPendingSelection = false;
  },
  clearLabs() {
    this.$refs.specTabs.formKey++;
    this.hasPendingSelection = false;
  },
  
  },
};
</script>

<style scoped>
  .bg-light-green {
    background-color: #4caf50; 
    font-weight: bold;
    color: white;
    text-align: center;
  }
  .bg-green {
    background-color: #008000; 
    font-weight: bold;
    color: white;
    text-align: center;
  }
  .bg-light-green {
    background-color: #8BC34A;
    font-weight: bold;
    color: black; 
    text-align: center;
  }
  .bg-yellow {
    background-color: #ffeb3b;
    font-weight: bold;
    color: black;
    text-align: center;
  }
  .bg-orange {
    background-color: #ff9800;
    font-weight: bold;
    color: black;
    text-align: center;
  }
  .bg-red {
    background-color: #f44336;
    font-weight: bold;
    color: black;
    text-align: center;
  }
  .bg-dark-red {
    background-color: #b71c1c;
    font-weight: bold;
    color: white;
    text-align: center;
  }
  .bg-darkest-red {
    background-color: #7f0000; 
    font-weight: bold;
    color: white;
    text-align: center;
  }
  .compact-risk-table {
  max-width: 250px;       
  font-size: 0.85rem;     
}

.compact-risk-table .risk-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.compact-risk-table .risk-percentage {
  font-size: 0.85rem;
  margin-bottom: 1rem;
}

.compact-risk-table .v-simple-table thead th,
.compact-risk-table .v-simple-table tbody td {
  padding: 4px 8px !important; 
  font-size: 0.8rem;
}

.color-box {
  width: 18px;
  height: 18px;
}

</style>